var newsletter = new function() {

    var me = this;

    this.bindEvents = function() {
        $("[data-form-newslettersubscribe]").bind("submit", function() {
            var form = $(this);
            var params = {
              'email': form.find("input[type='email']").val(),
              'lang': $('html').attr('lang'),
              '_token': window.Laravel.csrfToken
            };
            if($(this).valid()){
              $.post("/module/newsletter/subscribe",params, function(response) {
                  if(parseInt(response.code) == 1)
                    form.find("input[type='email']").val('');
                  $("[data-form-newslettermsg]").html( "<span class='newsletter__errorWrap'>" + response.msg + "</span>" );
              },"json");
            }
            return false;
        });
    };
}

$(document).ready(function() {
    newsletter.bindEvents();
});

$(document).ready(function () {
  var elements = document.querySelectorAll('.js-gallery');
  if(elements && elements.length>0){
    for(var i=0;i<elements.length;i++){
        $(".js-gallery").eq(i).magnificPopup({
            delegate: 'a',
            type: 'image',
            tLoading: 'Ładowanie #%curr%...',
            mainClass: 'mfp-with-zoom',
            tClose: 'Zamknij',
            removalDelay: 400,
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                tPrev: 'Poprzednie',
                tNext: 'Następne',
                preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
                tCounter: '%curr% z %total%'
            },
            image: {
                tError: '<a href="%url%">Zdjęcie #%curr%</a> nie może być załadowane.',
                /* Galerie, w których podpis to nazwa pliku, trzymają go w data-title -
                   inaczej przeglądarka pokazywałaby ją w swojej dymce na hover. Pozostałe
                   galerie w serwisie nadal używają title, więc bierzemy je jako zapas. */
                titleSrc: function (item) {
                    return item.el.attr('data-title') || item.el.attr('title');
                }
            }
        });
    }
  }






  // scrolledGallery for mobiles
  let scrolledGallery = function() {
      $('.js-scrolledGallery').slick({
          arrows: true,
          speed: 700,
          fade: true,
          autoplaySpeed: 7000,
          dots: true,
          infinite: true,
          autoplay: false,
          responsive: [
            {
              breakpoint: 1240,
              settings: {
                dots: false,
              }
            }
          ]
      });
  }
  if ($(window).width() < 800) {
      scrolledGallery();
  }
  $(window).on('resize', function(){
      if ($(window).width() < 800) {
          scrolledGallery();
      }
  });

});

$(document).ready(function(){

    var elements = $(".js-videoSlider");

    if( elements.length > 0 ) {

        for(var i=0; i<elements.length;i++){
          $(elements[i]).slick({
              dots: false,
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: true,
              responsive: [
              {
                breakpoint: 760,
                settings: {
                 slidesToShow: 3,
               },
               breakpoint: 500,
               settings: {
                slidesToShow: 3,
              }
              }
]
          });
        }



        $('.js-videoSlider').each(function(){
            if ( $(this).find('.slick-slide').length <= 4 ) {
              $(this).closest('.videoSlider').addClass('short');
            }
        });
    }

    $("[data-videourl]").on("click", function () {
        var el = $(this);
        var url = el.data("videourl");
        var instance = el.closest('.videoSlider__bottom').parent();
        instance.find('[data-target]').attr("src", url);
        instance.find('.videoSlide .slick-slide').removeClass('slick-current');
        el.closest('.slick-slide').addClass('slick-current');
    });

    $("[data-videourl]").eq(0).trigger("click");

});

$(document).ready(function(){
    $(".contentBlock").find("table").wrap("<div class='styledTable'></div>");
});



//responsive table
document.querySelectorAll('table').forEach(table => {

  const headers = Array.from(table.querySelectorAll('thead td, thead th'))
        .map(th => th.textContent.trim());

    table.querySelectorAll('tbody tr').forEach(row => {
        Array.from(row.children).forEach((cell, index) => {
            if (headers[index]) {
                cell.setAttribute('data-label', headers[index]);
            }
        });
    });
});

$(document).ready(function(){
    var popupLink = $(".hiddenPopup");
    if(popupLink.length == 1){
      var type = popupLink.data("type");

      if(type!=null){
        type = type.replace(/\s*$/,"");

        if(type === "inline") {
            popupLink.magnificPopup({
                mainClass: 'mfp-with-zoom',
                removalDelay: 400,
                items: {
                    src: '#popup',
                    type: type
                }
            });
        } else{
            popupLink.magnificPopup({
                type: 'iframe',
                mainClass: 'mfp-with-zoom',
                removalDelay: 400,
                iframe: {
                    markup: '<div class="mfp-iframe-scaler">' +
                    '<div class="mfp-close"></div>' +
                    '<iframe id="player" class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
                    '</div>',
                    patterns: {
                        youtube: {
                            index: 'youtube.com/',
                            id: 'v=',
                            src: 'h%id%&autoplay=1'
                        }
                    }
                }
            });
        }
      }
    }
});

$(window).on('load',function () {
    $(".hiddenPopup").trigger("click");
});

$(document).ready(function () {

  // scrolledGallery for mobiles
  let scrolledLogotypes = function() {
      $('.sliderLogotypes').slick({
          arrows: true,
          speed: 700,
          fade: true,
          autoplaySpeed: 7000,
          dots: true,
          slidesToShow:1,
          infinite: true,
          autoplay: false,
      });
  }
  if ($(window).width() < 500) {
      scrolledLogotypes();
  }
  $(window).on('resize', function(){
      if ($(window).width() < 500) {
          scrolledLogotypes();
      }
  });

});

// trainig tabs
console.log('test');
function toggleTrainingsTab() {
  const toggleButtons = $('.trainingTab');


  toggleButtons.on('click', function(event) {
    toggleButtons.removeClass('active');
    $(this).addClass('active');

    const index = toggleButtons.index(this);

    $('.trainingDetails').hide();
    $('.trainingDetails').eq(index).show();
  })
}


// TRAININGS ADD NEW PARTICIPANT

const firstRemoveButton = $(".remove-button-first");
const firstRowInput = $(".iterated-input--first");

  firstRemoveButton.on('click', function() {
      firstRowInput.remove();
  });

let countRegisterRow = 0;
function addInputs() {
  countRegisterRow++;
  const inputDiv = $('<div class="iterated-input row"></div>');

  const labels = trainingLabels;
  const names = ['name', 'phone', 'email'];

  labels.forEach((labelText, index) => {
      const inputItem = $(`<div class="iterated-input__item col-md-4"></div>`);
      const styledForm = $(`<div class="styledForm__row"></div>`);
      const type = names[index] === 'email' ? 'email' : 'text';
      const label = $(`<label for="members[${countRegisterRow}][${names[index]}]" class="styledForm__label">${labelText}</label>`);
      const input = $(`<input type="${type}" id="members[${countRegisterRow}][${names[index]}]" name="members[${countRegisterRow}][${names[index]}]" class="styledFormItems styledFormItems--input" placeholder="${insertLabel}">`);

      styledForm.append(label);
      styledForm.append(input);
      inputItem.append(styledForm);
      inputDiv.append(inputItem);
  });

  const removeButton = $('<button type="button" class="remove-button">X</button>');
  removeButton.on('click', function() {
      inputDiv.remove();
  });

  inputDiv.append(removeButton);
  $('.iterated-inputs').append(inputDiv);
}



$(document).ready(function() {
  toggleTrainingsTab();
  $('#add-row').on('click', function() {
      addInputs();
  });
});

var category = new function() {
    var me = this;
    this.containerAmong;
    this.durningRequest = false;

    this.showNext = function(el) {
        var categoryBox = $(el).closest("[data-category-box]");
        var currentPage = parseInt(categoryBox.attr("data-category-currentpage"));
        var container = categoryBox.find("[data-category-container]");
        /*if (container.eq(currentPage).length > 0) {
            container.eq(currentPage).fadeIn();
        }
        if (container.eq(currentPage + 1).length == 0) {
            $(el).fadeOut();
        }
        $(el).closest("[data-category-box]").attr("data-category-currentpage", currentPage + 1);*/
        var data = {
            category_id: categoryBox.data("category-id"),
            page_nr: parseInt(categoryBox.data("category-page")) + 1,
            _token: Laravel.csrfToken,
            language: $('html').attr('lang')
        };

        if(typeof categoryBox.find("[data-category-thumbnail]")!=="undefined" && categoryBox.attr("data-category-thumbnail")!=""){
          data.thumbnail = categoryBox.attr("data-category-thumbnail");
        }

        if(typeof categoryBox.find("[data-module]")!=="undefind"){
          data.module = categoryBox.attr("data-module");
        }

        if(typeof categoryBox.find("[data-listing]")!=="undefind"){
          data.listing = categoryBox.attr("data-listing");
        }

        var requestParams = document.location.href.split('/').pop().split(',');
        if(requestParams.length > 1 && parseInt(requestParams[1])>=1 && parseInt(requestParams[1])<=12)
          data.month = requestParams[1];
        if(requestParams.length == 2)
          data.year = requestParams[1];
        else if(requestParams.length > 2)
          data.year = requestParams[2];

        if(!me.durningRequest)
          me.getPosts(data,categoryBox);
    };

    /**
     * data:
     *  category_id
     *  page_nr
     *  _token
     */
    this.getPosts = function(data,categoryBox){
      me.durningRequest = true;
      $.ajax({
          url: "/module/postfromcategory",
          method: "POST",
          data: data,
          dataType: "json",
          success: function (data) {
              if (data.posts.length == 0) {
                  $("[data-category-loadpage]").remove();
              } else {
                  var template = $("#entry-template").html();
                  var stone = Handlebars.compile(template)(data);
                  var $items = $.parseHTML(stone);
                  if(data.posts.length<parseInt(categoryBox.data('category-perpage')))
                    $("[data-category-loadpage]").remove();

                  categoryBox.find("[data-category-container]").append($items);
                  categoryBox.data('category-page', data.page);
                  $(".loader").data("offset", data.offset);
              }
              me.durningRequest = false;

              if(data.next==0)
                categoryBox.find('div[data-category-loadpage]').addClass('hidden');
          }
      });
    };

    this.bindEvents = function() {
        $("[data-category-loadpage]").bind("click", function() {
            me.showNext($(this));
        });
    };

};

$(document).ready(function () {
    if (document.querySelector('[data-category-loadpage]'))
      category.bindEvents();

    if (document.querySelector('.loader')){
      $('.loader').on('inview', function (event, isInView) {
          if (isInView) {
              var data = {
                  category_id: $("[data-category-id]").data("category-id"),
                  page_nr: parseInt($("[data-category-page]").data("category-page")) + 1,
                  _token: Laravel.csrfToken
              };

              category.getPosts(data);
          }
      });
    }
});

Handlebars.registerHelper('dotdotdot', function(str,length) {
  if (str.length > length)
    return str.substring(0,length-1) + '...';
  return str;
});

Handlebars.registerHelper('compare', function (v1, operator, v2, options) {
   'use strict';
   console.log(options);
   var operators = {
     '==': v1 == v2 ? true : false,
     '===': v1 === v2 ? true : false,
     '!=': v1 != v2 ? true : false,
     '!==': v1 !== v2 ? true : false,
     '>': v1 > v2 ? true : false,
     '>=': v1 >= v2 ? true : false,
     '<': v1 < v2 ? true : false,
     '<=': v1 <= v2 ? true : false,
     '||': v1 || v2 ? true : false,
     '&&': v1 && v2 ? true : false
   }
   if (operators.hasOwnProperty(operator)) {
     if (operators[operator]) {
       return options.fn(this);
     }
     return options.inverse(this);
   }
   return console.error('Error: Expression "' + operator + '" not found');
});

Handlebars.registerHelper('indexof', function(array,index) {
  if(array.length > index)
    return array[index];
  else
    return "";
});

Handlebars.registerHelper('slugify', function(value) {
  return this[value].toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-');
});

$(document).ready(function () {
  $('.js-openMenu').on("click", function () {
    $(this).toggleClass('active');
    $('.mobileMenu').toggleClass('opened');
    $('body').addClass('noscroll');
  });

  $('.js-close').on("click", function () {
    $('.mobileMenu').removeClass('opened');
    $('body').removeClass('noscroll');
  });

  $('body').on("click", '.js-prev', function () {
    
    var el = $(this);
    $(".mobileMenu ul.opened").removeClass("opened");
    $("[data-menu].actived").removeClass("actived");
    $(".js-prev").remove();
  });

  $('.mobileMenu li').each(function() {
    if ( $(this).find('ul').length ) {
      $(this).addClass('withSubmenu');
      $(this).find('a').append('<span class="mobileMenu__submenuSwitcher"></span>');
    }
  });
  

  /* Podmenu rozwija kliknięcie w cały element listy, nie tylko w strzałkę - na telefonie
     trafienie w sam trójkącik było za trudne. Strzałka siedzi w środku linku rodzica
     (ten ma data-menu), więc wystarczy powiesić się na całym linku. */
  function submenuSwitcher() {
    $(".mobileMenu a[data-menu]").on("click", function (e) {
        e.preventDefault();
        var el = $(this);
        el.toggleClass("actived");
        el.next('ul').toggleClass("opened");
    });
  }
  submenuSwitcher();

  $('.js-searchBox .searchBox__icon').on('click', function() {
    $(this).parent().toggleClass('active');
    $('.js-searchBox input').focus();
    $('.mobileMenu__language').toggleClass('hide');
  });

});


document.querySelectorAll('.mobileMenu ul.mobileMenu__list li a[data-menu]').forEach(function(el) {
  el.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
  });
});
var offerBoxesSlider = document.querySelector('.offerBoxesSlider');
if (offerBoxesSlider) {
  var offerBoxesSection = offerBoxesSlider.closest('.investSection');
  var offerBoxesNav = offerBoxesSection ? offerBoxesSection.querySelector('.investSection__nav') : null;

  /* Strzałki chowamy tylko wtedy, gdy nie ma czym przesuwać. Wcześniej decydowała stała
     "mniej niż 4 slajdy", ale liczba widocznych slajdów zależy od szerokości ekranu -
     na mobile widać jeden, więc przy trzech inwestycjach strzałki są potrzebne.
     watchOverflow + isLocked liczy to za nas na każdym breakpoincie. */
  function odswiezOfferBoxesNav(sw) {
    if (offerBoxesNav) offerBoxesNav.hidden = sw.isLocked;
  }

  new Swiper('.offerBoxesSlider', {
    slidesPerView: 3,
    spaceBetween: 24,
    speed: 500,
    watchOverflow: true,
    navigation: {
      prevEl: '.investSection__nav-btn--prev',
      nextEl: '.investSection__nav-btn--next',
    },
    breakpoints: {
      300: {
        slidesPerView: 1,
      },
      576: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 3,
      },
    },
    on: {
      init: odswiezOfferBoxesNav,
      breakpoint: odswiezOfferBoxesNav,
      resize: odswiezOfferBoxesNav,
      lock: odswiezOfferBoxesNav,
      unlock: odswiezOfferBoxesNav,
    },
  });
}

 // imageslider
 var elements = document.querySelectorAll('.js-sliderGallery');
 if ( elements.length>0){
   $('.js-sliderGallery').slick({
       arrows: true,
       speed: 700,
       autoplaySpeed: 7000,
       dots: true,
       infinite: true,
       autoplay: true,
       slidesPerRow: 5,
       rows: 2,
       responsive: [
         {
           breakpoint: 678,
           settings: {
             slidesPerRow: 2,
             rows: 2,
           }
         }
       ]
   });
 }


//logoSlider
if ( $('.js-logoSlider').length ){
  $('.js-logoSlider').slick({
      arrows: true,
      speed: 700,
      autoplaySpeed: 7000,
      dots: true,
      infinite: true,
      autoplay: false,
      slidesToShow: 6,
      slidesToScroll: 6,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
              slidesToShow: 4,
              slidesToScroll: 4
          }
        },
        {
          breakpoint: 900,
          adaptiveHeight: false,
          settings: {
              slidesToShow: 2,
              slidesToScroll: 2
          }
        }
        ,
        {
          breakpoint: 600,
          adaptiveHeight: true,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1
          }
        }
      ]
  });
}
//productSlider
if ( $('.js-productSlider').length ) {
  $('.js-productSlider').slick({
      speed: 700,
      fade: true,
      autoplaySpeed: 7000,
      dots: true,
      infinite: true,
      autoplay: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 1240,
          settings: {
            dots: false
          }
        }
      ]
  });
}

function setTimeSlider() {
  let sliderOpac = $('.slider');
  sliderOpac.addClass('sliderShow');
}

setTimeout(setTimeSlider, 100);

//testimonials
if ( $('.homeTestimonials__slider').length ) {
  $('.homeTestimonials__slider').slick({
      speed: 700,
      fade: true,
      autoplaySpeed: 7000,
      dots: true,
      infinite: true,
      autoplay: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 1240,
          settings: {
            dots: false
          }
        }
      ]
  });
}



document.querySelectorAll('.investGallerySwiper').forEach(function (swiperEl) {
    var wrap = swiperEl.closest('.investGallery__wrap');
    if (!wrap) return;

    /* Gdy zdjęć jest tyle, co widocznych naraz, nie ma czym przewijać - wtedy chowamy cały
       rząd ze strzałkami i paskiem, zamiast pokazywać wygaszone strzałki. isLocked liczy to
       za nas na każdym breakpoincie (watchOverflow niżej). */
    var nav = wrap.querySelector('.investGallery__nav');

    function odswiezNawigacje(sw) {
        if (nav) nav.hidden = sw.isLocked;
    }

    new Swiper(swiperEl, {
        slidesPerView: 4,
        spaceBetween: 24,
        slidesPerGroup: 1,
        watchOverflow: true,
        on: {
            init: odswiezNawigacje,
            breakpoint: odswiezNawigacje,
            resize: odswiezNawigacje,
            lock: odswiezNawigacje,
            unlock: odswiezNawigacje,
        },
        scrollbar: {
            el: wrap.querySelector('.investGallery__scroll'),
            draggable: true,
        },
        navigation: {
            nextEl: wrap.querySelector('.investGallery__btn--next'),
            prevEl: wrap.querySelector('.investGallery__btn--prev'),
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 12,
            },
            600: {
                slidesPerView: 2,
                spaceBetween: 16,
            },
            1024: {
                slidesPerView: 4,
                spaceBetween: 24,
            },
        },
    });
});

document.querySelectorAll('.investGalleryTabs__tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-gallery-tab');
        var tabsWrap = tab.closest('.investGalleryTabs');
        var panelsContainer = tabsWrap ? tabsWrap.parentElement : null;
        if (!tabsWrap || !panelsContainer) return;

        tabsWrap.querySelectorAll('.investGalleryTabs__tab').forEach(function (t) {
            t.classList.remove('investGalleryTabs__tab--active');
        });
        tab.classList.add('investGalleryTabs__tab--active');

        panelsContainer.querySelectorAll('.investGalleryTabs__panel').forEach(function (panel) {
            var isActive = panel.getAttribute('data-gallery-panel') === target;
            panel.classList.toggle('investGalleryTabs__panel--active', isActive);

            if (isActive) {
                var panelSwiperEl = panel.querySelector('.investGallerySwiper');
                if (panelSwiperEl && panelSwiperEl.swiper) {
                    panelSwiperEl.swiper.update();
                }
            }
        });
    });
});



// Baner na stronie głównej. Osobne instancje dla wersji desktop i mobile - oba
// szablony renderują tę samą strukturę, każdy w swoim wrapperze, więc nawigację
// i kropki szukamy wewnątrz konkretnego .banerHomeSlider, a nie globalnie.
document.querySelectorAll('.banerHomeSlider').forEach(function (sliderEl) {
    var swiperEl = sliderEl.querySelector('.banerHomeSlider__swiper');
    if (!swiperEl) return;

    var slidesCount = swiperEl.querySelectorAll('.swiper-slide').length;
    if (slidesCount < 2) return;

    new Swiper(swiperEl, {
        slidesPerView: 1,
        speed: 500,
        loop: true,
        autoplay: {
            delay: 6000,
            disableOnInteraction: false,
        },
        navigation: {
            prevEl: sliderEl.querySelector('.banerHomeSlider__nav-btn--prev'),
            nextEl: sliderEl.querySelector('.banerHomeSlider__nav-btn--next'),
        },
        pagination: {
            el: sliderEl.querySelector('.banerHomeSlider__dots'),
            clickable: true,
        },
    });
});


if (document.querySelector('.newsListMobile')) {
    new Swiper('.newsListMobile', {
        slidesPerView: 1,
        spaceBetween: 24,
        loop:true,
        navigation: {
            prevEl: '.newsListSliderMobile__nav-btn--prev',
            nextEl: '.newsListSliderMobile__nav-btn--next',
        },
        breakpoints: {
            576: {
                slidesPerView: 2,
            },
        },
    });
}
/* Oś postępu prac na stronie inwestycji: taby etapów + osobna oś pod każdym tabem.
   Oś jedzie po jednym punkcie, widoczne 4 punkty na desktopie i 2 na mobile, strzałki
   stoją po bokach i chowają się, gdy punktów nie ma czym przesuwać (swiper.isLocked). */
document.querySelectorAll('.investProgress').forEach(function (section) {
  var panels = section.querySelectorAll('[data-progress-panel]');
  if (!panels.length) return;

  var tabs = section.querySelectorAll('[data-progress-tab]');
  var swipers = {};

  panels.forEach(function (panel) {
    var sliderEl = panel.querySelector('.investProgress__slider');
    if (!sliderEl) return;

    var prev = panel.querySelector('.investProgress__nav-btn--prev');
    var next = panel.querySelector('.investProgress__nav-btn--next');

    function odswiezStrzalki(sw) {
      if (prev) prev.hidden = sw.isLocked;
      if (next) next.hidden = sw.isLocked;
      dopasujDaty();
    }

    /* Data ma rozmiar z makiety, dopóki się mieści. Pełne daty ("27.02.2021") są jednak
       dłuższe od kolumny, a im węższy ekran, tym bardziej - wtedy zbijamy rozmiar tak,
       żeby najdłuższa data weszła w kolumnę. Mierzymy zawsze po zdjęciu --date-font,
       czyli przy rozmiarze bazowym, inaczej przy każdym przeliczeniu tekst by się kurczył.
       Podpisy typu "07.2024" mieszczą się od razu i zostają przy makietowych 36px. */
    function dopasujDaty() {
      var slajdy = panel.querySelectorAll(".investProgress__stage");
      if (!slajdy.length) return;

      panel.style.removeProperty("--date-font");

      var kolumna = slajdy[0].getBoundingClientRect().width;
      var pierwszaData = slajdy[0].querySelector(".investProgress__stage-date p");
      if (!kolumna || !pierwszaData) return;

      var najszersza = 0;
      Array.prototype.forEach.call(slajdy, function (slajd) {
        var data = slajd.querySelector(".investProgress__stage-date p");
        if (data) najszersza = Math.max(najszersza, data.getBoundingClientRect().width);
      });
      if (!najszersza || najszersza <= kolumna) return;

      var bazowy = parseFloat(window.getComputedStyle(pierwszaData).fontSize);
      panel.style.setProperty("--date-font", Math.floor(bazowy * (kolumna - 2) / najszersza) + "px");
    }

    swipers[panel.getAttribute('data-progress-panel')] = new Swiper(sliderEl, {
      slidesPerView: 2,
      slidesPerGroup: 1,
      spaceBetween: 16,
      speed: 500,
      watchOverflow: true,
      breakpoints: {
        769: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
      },
      navigation: {
        prevEl: prev,
        nextEl: next,
      },
      on: {
        init: odswiezStrzalki,
        breakpoint: odswiezStrzalki,
        resize: odswiezStrzalki,
        lock: odswiezStrzalki,
        unlock: odswiezStrzalki,
      },
    });
  });

  /* Etapy mają różną liczbę terminów (a bywa i etap bez terminów), więc panele mają różną
     wysokość i przełączanie zakładek przesuwało treść pod sekcją. Mierzymy najwyższy panel
     i dajemy wszystkim takie samo min-height. Pomiar wymaga chwilowego odsłonięcia panelu -
     dzieje się to w jednym przebiegu, bez przemalowania. */
  function rownajWysokoscOsi() {
    var najwyzszy = 0;

    panels.forEach(function (panel) {
      panel.style.minHeight = '';
      var bylUkryty = panel.hidden;
      if (bylUkryty) panel.hidden = false;
      najwyzszy = Math.max(najwyzszy, panel.offsetHeight);
      if (bylUkryty) panel.hidden = true;
    });

    if (!najwyzszy) return;
    panels.forEach(function (panel) {
      panel.style.minHeight = najwyzszy + 'px';
    });
  }

  rownajWysokoscOsi();
  window.addEventListener('resize', rownajWysokoscOsi);

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var index = tab.getAttribute('data-progress-tab');

      tabs.forEach(function (other) {
        var czyAktywny = other === tab;
        other.classList.toggle('investProgress__tab--active', czyAktywny);
        other.setAttribute('aria-selected', czyAktywny ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-progress-panel') !== index;
      });

      /* Kazdy etap ma swoj procent postepu - podmieniamy go razem z osia. Kopii jest dwie
         (nagłówek na desktopie, rząd zakładek na mobile), więc lecimy po wszystkich. */
      var procentEtapu = tab.getAttribute('data-progress-percent');
      if (procentEtapu) {
        section.querySelectorAll('.investProgress__percent-value').forEach(function (procent) {
          procent.textContent = procentEtapu;
        });
      }

      /* Swiper w schowanym panelu policzył szerokości przy zerowym oknie, więc po
         pokazaniu trzeba go przeliczyć - inaczej slajdy zostają z szerokością 0. */
      /* Panel liczył szerokości przy zerowym oknie (był schowany), więc po pokazaniu
         trzeba go przeliczyć. Drugi przebieg w requestAnimationFrame jest po to, żeby
         mierzył już po ułożeniu strzałek - inaczej slajdy zostają z szerokością liczoną
         dla osi bez nich. */
      var swiper = swipers[index];
      if (swiper) {
        swiper.update();
        requestAnimationFrame(function () {
          swiper.update();
          swiper.slideTo(0, 0);
          swiper.emit("resize");
        });
      }
    });
  });
});

// Przełącznik widoku karty inwestycji: lista (mapa + filtry + lista mieszkań) albo 3D.
// Panele listy są w dwóch miejscach DOM (mapa siedzi w nagłówku strony, a filtry i lista
// pod nim), dlatego przełączamy je po atrybucie, a nie po jednym wspólnym rodzicu.
(function () {
  var tabs = document.querySelectorAll('[data-invest-view]');
  if (!tabs.length) return;

  var panels = document.querySelectorAll('[data-invest-view-panel]');

  function setView(view) {
    panels.forEach(function (panel) {
      if (panel.getAttribute('data-invest-view-panel') === view) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    tabs.forEach(function (tab) {
      tab.classList.toggle('investPageViews__tab--active', tab.getAttribute('data-invest-view') === view);
    });

    // Mapa liczy współrzędne stref z realnych rozmiarów obrazka - po odsłonięciu
    // panelu trzeba je przeliczyć, bo w ukryciu wymiary wynosiły zero.
    if (view === 'list') window.dispatchEvent(new Event('resize'));
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      setView(tab.getAttribute('data-invest-view'));
    });
  });
})();


document.querySelectorAll('.investMapInteractive').forEach(function (mapEl) {
  var floorButtons = mapEl.querySelectorAll('[data-invest-map-floor]');
  var buildingButtons = mapEl.querySelectorAll('button[data-invest-map-area-building]');
  /* Pasek pięter bywa na stronie w dwóch egzemplarzach: inwestycja z dwiema klatkami ma
     osobny pasek na każdą z nich. Każdy dostaje więc własne strzałki - te ze swojego
     .investMapInteractive__row - żeby obracały tylko swoją listę. */
  var sliders = Array.prototype.map.call(mapEl.querySelectorAll('[data-invest-map-list]'), function (listEl) {
    var row = listEl.closest('.investMapInteractive__row') || mapEl;
    return {
      list: listEl,
      buttons: Array.prototype.slice.call(row.querySelectorAll('[data-invest-map-scroll]')),
    };
  });
  /* Plakietka "Piętro / Wolnych mieszkań" bywa renderowana poza .investMapInteractive
     (pod obrazkiem), więc po nieznalezieniu jej w środku szukamy w panelu widoku, w którym
     ta mapa siedzi - bez tego hover po piętrach nie miałby czego aktualizować. Szukanie po
     całym dokumencie byłoby za szerokie: gdy na stronie stoją dwie mapy, ta bez własnej
     plakietki pisałaby do plakietki sąsiada. */
  var badgeScope = mapEl.closest('[data-invest-view-panel]') || mapEl;
  var floorValue = mapEl.querySelector('[data-invest-map-floor-value]')
    || badgeScope.querySelector('[data-invest-map-floor-value]');
  var countValue = mapEl.querySelector('[data-invest-map-count-value]')
    || badgeScope.querySelector('[data-invest-map-count-value]');
  // data-invest-map-image, nie #investMapImage - id byłoby w dokumencie zdublowane przy dwóch mapach
  var image = mapEl.querySelector('[data-invest-map-image]') || mapEl.querySelector('#investMapImage');
  var activeFloor = mapEl.querySelector('.investMapInteractive__floor--active') || floorButtons[0];

  if (!image) return;

  var SVG_NS = 'http://www.w3.org/2000/svg';
  // musi odpowiadać czasowi przejścia .investMapInteractive__hl w _productPage.scss
  var HIGHLIGHT_FADE_MS = 250;
  // fiolet projektu - ten sam, którym świecą dostępne budynki (InvestmentBuilding::getPlanLayerColor)
  var FLOOR_HIGHLIGHT = '#4C2178';
  // szary sprzedanych/zajętych mieszkań - ten sam co Apartment::getPlanLayerColor
  var SOLD_COLOR = '#7B777F';

  var wrapper = image.closest('.investMapInteractive__image');
  var overlay = document.createElementNS(SVG_NS, 'svg');
  overlay.setAttribute('class', 'investMapInteractive__overlay');
  overlay.style.position = 'absolute';
  overlay.style.top = '0';
  overlay.style.left = '0';
  overlay.style.width = '100%';
  overlay.style.height = '100%';
  overlay.style.pointerEvents = 'none';

  /* Trzy warstwy w jednym svg, kolejność decyduje o tym, co jest na wierzchu:
     strefy mieszkań (stale, półprzezroczyste), podświetlenie najechanej strefy
     (pełny kolor) i na samej górze numery lokali, żeby podświetlenie ich nie zakryło. */
  var planGroup = document.createElementNS(SVG_NS, 'g');
  var highlightGroup = document.createElementNS(SVG_NS, 'g');
  var labelGroup = document.createElementNS(SVG_NS, 'g');
  overlay.appendChild(planGroup);
  overlay.appendChild(highlightGroup);
  overlay.appendChild(labelGroup);

  if (wrapper) {
    wrapper.style.position = wrapper.style.position || 'relative';
    wrapper.appendChild(overlay);
  }

  /* Liczba z serwera na wejściu: przy rzucie osiedla suma z całej inwestycji, przy planie
     budynku/piętra liczba aktywnego piętra. Wracamy do niej po zjechaniu kursorem ze
     strefy albo z przycisku. */
  var defaultCount = countValue ? countValue.textContent : null;

  function showCount(value) {
    if (!countValue) return;
    countValue.textContent = (value === null || value === '') ? defaultCount : value;
  }

  function showBadge(btn) {
    if (!btn) return;
    /* data-invest-map-floor-label ma pierwszeństwo: przy dwóch kolumnach klatek podpis na
       kółku różni się od numeru piętra z CMS-u (klatka 2 jest o jedno niżej), a plakietka
       ma pokazywać to, co widzi użytkownik, nie numer, po którym idzie link. */
    var podpis = btn.getAttribute('data-invest-map-floor-label');
    if (floorValue) {
      floorValue.textContent = podpis !== null
        ? podpis
        : (btn.getAttribute('data-invest-map-floor-number') || btn.getAttribute('data-invest-map-floor'));
    }
    showCount(btn.getAttribute('data-invest-map-count'));
  }

  /* Przycisk piętra z listy obok obrazka, odpowiadający tej strefie na elewacji - tam
     siedzą numer piętra i liczba wolnych mieszkań dla plakietki. Szukamy po całej mapie,
     nie po jednej liście: przy dwóch kolumnach klatek najwyższy poziom ma knopkę tylko
     w drugiej z nich. */
  function floorButtonFor(area) {
    var floorId = area.getAttribute('data-invest-map-area-floor');
    if (!floorId) return null;
    return mapEl.querySelector('button[data-invest-map-floor="' + floorId + '"]');
  }

  /* Przycisk w panelu po prawej odpowiadający tej strefie: budynek/etap po
     data-invest-map-building-id (mają je też niedostępne), piętro po swoim id.
     Używamy go do podświetlenia przycisku, gdy kursor jest na mapie - odwrotnie
     niż podświetlenie strefy przy najechaniu na przycisk. */
  function buttonForArea(area) {
    var buildingId = area.getAttribute('data-invest-map-building-id');
    if (buildingId) return mapEl.querySelector('button[data-invest-map-building-id="' + buildingId + '"]');
    return floorButtonFor(area);
  }

  var HOVER_CLASS = 'investMapInteractive__floor--hovered';

  function highlightButton(btn) {
    clearButtonHighlight();
    if (btn) btn.classList.add(HOVER_CLASS);
  }

  function clearButtonHighlight() {
    mapEl.querySelectorAll('.' + HOVER_CLASS).forEach(function (el) {
      el.classList.remove(HOVER_CLASS);
    });
  }

  function currentAreas() {
    return image.parentNode.querySelectorAll('map area, area[data-invest-map-area-floor]');
  }

  function pointsFromArea(area) {
    var shape = area.getAttribute('shape');
    var defaultCoords = (area.getAttribute('data-coords') || area.getAttribute('coords') || '').split(',').map(parseFloat);
    var point = (area.getAttribute('data-point') || '0,0').split(',').map(parseFloat);
    var widthPercent = parseFloat(area.getAttribute('data-width') || 0) / 100;
    var heightPercent = parseFloat(area.getAttribute('data-height') || 0) / 100;

    var imgWidth = image.clientWidth;
    var imgHeight = image.clientHeight;
    if (!imgWidth || !imgHeight) return null;

    var x = (point[0] / 100) * imgWidth;
    var y = (point[1] / 100) * imgHeight;
    var layerWidth = imgWidth * widthPercent;
    var layerHeight = imgHeight * heightPercent;

    if (shape === 'rect') {
      return { shape: shape, coords: [x, y, x + layerWidth, y + layerHeight] };
    }

    var coords = [];
    for (var i = 0; i < defaultCoords.length; i += 2) {
      coords.push(x + (defaultCoords[i] / 100) * layerWidth);
      coords.push(y + (defaultCoords[i + 1] / 100) * layerHeight);
    }
    return { shape: shape, coords: coords };
  }

  function rescaleAreas() {
    currentAreas().forEach(function (area) {
      var computed = pointsFromArea(area);
      if (!computed) return;
      area.setAttribute('coords', computed.coords.join(','));
    });
    renderPlanLayer();
  }

  function polygonPoints(coords) {
    var pts = [];
    for (var i = 0; i < coords.length; i += 2) {
      pts.push(coords[i] + ',' + coords[i + 1]);
    }
    return pts.join(' ');
  }

  function shapeFromComputed(computed) {
    var shape;
    if (computed.shape === 'rect') {
      shape = document.createElementNS(SVG_NS, 'rect');
      shape.setAttribute('x', computed.coords[0]);
      shape.setAttribute('y', computed.coords[1]);
      shape.setAttribute('width', computed.coords[2] - computed.coords[0]);
      shape.setAttribute('height', computed.coords[3] - computed.coords[1]);
    } else {
      shape = document.createElementNS(SVG_NS, 'polygon');
      shape.setAttribute('points', polygonPoints(computed.coords));
    }
    return shape;
  }

  function centerOfComputed(computed) {
    if (computed.shape === 'rect') {
      return [(computed.coords[0] + computed.coords[2]) / 2, (computed.coords[1] + computed.coords[3]) / 2];
    }
    var sumX = 0, sumY = 0, count = 0;
    for (var i = 0; i < computed.coords.length; i += 2) {
      sumX += computed.coords[i];
      sumY += computed.coords[i + 1];
      count++;
    }
    return count ? [sumX / count, sumY / count] : null;
  }

  /* Stały podkład: strefy, które mają swój kolor statusu, widać od razu jako
     półprzezroczyste wypełnienie - mieszkania na planie piętra (dostępne / zarezerwowane /
     sprzedane) i budynki na rzucie osiedla (dostępny / niedostępny). Strefy pięter na
     elewacji budynku koloru nie mają, więc jak dotąd podświetlają się dopiero na hover. */
  function renderPlanLayer() {
    planGroup.innerHTML = '';
    labelGroup.innerHTML = '';

    currentAreas().forEach(function (area) {
      var color = area.getAttribute('data-color');
      if (!color) return;
      /* Budynki na rzucie osiedla mają wyglądać jednakowo, dopóki się na nie nie najedzie -
         ich kolor rysujemy wyłącznie w warstwie hover, nie tutaj. */
      if (area.hasAttribute('data-invest-map-building-zone')) return;
      var computed = pointsFromArea(area);
      if (!computed) return;

      var number = area.getAttribute('data-apartment-number');
      // biała strefa potrzebuje fioletowego obrysu, inaczej zniknie na planie
      var hover = area.getAttribute('data-hover-color');
      var shape = shapeFromComputed(computed);
      shape.setAttribute('fill', color);
      shape.setAttribute('fill-opacity', hover ? '0.8' : '0.5');
      shape.setAttribute('stroke', hover || color);
      shape.setAttribute('stroke-width', '1');
      planGroup.appendChild(shape);

      if (!number) return;
      var center = centerOfComputed(computed);
      if (!center) return;
      var text = document.createElementNS(SVG_NS, 'text');
      text.setAttribute('x', center[0]);
      text.setAttribute('y', center[1]);
      text.setAttribute('text-anchor', 'middle');
      text.setAttribute('dominant-baseline', 'central');
      text.setAttribute('font-size', '12');
      text.setAttribute('font-weight', '600');
      text.setAttribute('fill', '#4C2178');
      text.setAttribute('stroke', '#fff');
      text.setAttribute('stroke-width', '3');
      text.setAttribute('paint-order', 'stroke');
      text.setAttribute('pointer-events', 'none');
      text.textContent = number;
      labelGroup.appendChild(text);
    });
  }

  /* Hover: wolne mieszkanie na fiolet (data-hover-color), budynek na swój kolor,
     piętro na elewacji na domyślny. Zarezerwowane i sprzedane zostają bez zmian. */
  /* Podpisy strefy na statycznym planie budynku. Ten sam poziom nazywa się inaczej
     w zależności od klatki schodowej (klatka 1 liczy o jedno piętro więcej niż klatka 2),
     więc strefa niesie dwa podpisy: data-label-right dla klatki 1 i data-label-left dla
     klatki 2. Skrajne poziomy mają tylko jeden z nich - na dole po prawej "Parter",
     a na górze po lewej "Piętro 6", bo po drugiej stronie jest tam już dach. */
  function rysujPodpisyStrefy(area, computed) {
    var lewy = area.getAttribute('data-label-left');
    var prawy = area.getAttribute('data-label-right');
    if (!lewy && !prawy) return;

    var xs = [], ys = [];
    for (var i = 0; i < computed.coords.length; i += 2) {
      xs.push(computed.coords[i]);
      ys.push(computed.coords[i + 1]);
    }

    /* Pas jest pochylony, więc podpis stawiamy przy jego lewej i prawej krawędzi,
       w połowie ich wysokości - inaczej tekst wisiałby w powietrzu nad skosem. */
    var lewaX = Math.min.apply(null, xs);
    var prawaX = Math.max.apply(null, xs);
    var margines = (prawaX - lewaX) * 0.02;

    /* Środek grubości pasa dokładnie w tym x, w którym stoi podpis: przecinamy wielokąt
       pionową linią i bierzemy połowę między najwyższym i najniższym przecięciem.
       Uśrednianie samych wierzchołków tu nie wystarczało - podpis stoi z marginesem od
       krawędzi, a przy skosie górna i dolna granica są tam już przesunięte w dół, więc
       tekst odchodził od środka pasa tym bardziej, im większy skos. */
    function srodekPrzyX(x) {
      var przeciecia = [];
      var n = computed.coords.length / 2;
      for (var i = 0; i < n; i++) {
        var j = (i + 1) % n;
        var x1 = computed.coords[i * 2], y1 = computed.coords[i * 2 + 1];
        var x2 = computed.coords[j * 2], y2 = computed.coords[j * 2 + 1];
        // krawędź pionowa: liczy się tylko wtedy, gdy linia trafia dokładnie w nią
        if (x1 === x2) {
          if (x1 === x) { przeciecia.push(y1); przeciecia.push(y2); }
          continue;
        }
        if (x < Math.min(x1, x2) || x > Math.max(x1, x2)) continue;
        przeciecia.push(y1 + (y2 - y1) * ((x - x1) / (x2 - x1)));
      }
      if (!przeciecia.length) return (Math.min.apply(null, ys) + Math.max.apply(null, ys)) / 2;
      return (Math.min.apply(null, przeciecia) + Math.max.apply(null, przeciecia)) / 2;
    }

    function dodajTekst(tekst, x, y, anchor) {
      var t = document.createElementNS(SVG_NS, 'text');
      t.setAttribute('x', x);
      t.setAttribute('y', y);
      t.setAttribute('text-anchor', anchor);
      t.setAttribute('dominant-baseline', 'central');
      t.setAttribute('font-size', '16');
      t.setAttribute('font-weight', '300');
      t.setAttribute('fill', '#fff');
      t.setAttribute('stroke', 'rgba(0,0,0,0.35)');
      t.setAttribute('stroke-width', '3');
      t.setAttribute('paint-order', 'stroke');
      t.setAttribute('pointer-events', 'none');
      t.textContent = tekst.toUpperCase();
      highlightGroup.appendChild(t);
    }

    var xLewy = lewaX + margines;
    var xPrawy = prawaX - margines;
    if (lewy) dodajTekst(lewy, xLewy, srodekPrzyX(xLewy), 'start');
    if (prawy) dodajTekst(prawy, xPrawy, srodekPrzyX(xPrawy), 'end');
  }

  /* Statyczna strefa może odpowiadać dwóm numerom pięter naraz (jeden poziom to co innego
     dla każdej klatki), dlatego data-floors bywa listą - podświetlamy wtedy oba przyciski. */
  function highlightFloorButtons(area) {
    var lista = area.getAttribute('data-floors');
    if (!lista) return false;

    clearButtonHighlight();
    /* querySelectorAll po całym mapEl, nie jedno trafienie w liście: przy dwóch kolumnach
       klatek ten sam numer piętra z CMS-u ma dwie knopki (w każdej kolumnie po jednej,
       z różnymi podpisami) i podświetlić trzeba obie. Zawężenie do "button" jest istotne -
       ten sam atrybut niosą też strefy na rysunku. */
    lista.split(',').forEach(function (numer) {
      mapEl.querySelectorAll('button[data-invest-map-floor-number="' + numer.trim() + '"]').forEach(function (btn) {
        btn.classList.add(HOVER_CLASS);
      });
    });
    return true;
  }

  function highlightArea(area) {
    highlightGroup.innerHTML = '';

    if (!area) return;
    var color = area.getAttribute('data-color');
    var hover = area.getAttribute('data-hover-color');
    var isBuildingZone = area.hasAttribute('data-invest-map-building-zone');
    if (color && !hover && !isBuildingZone) return;

    var computed = pointsFromArea(area);
    if (!computed) return;

    // piętro na elewacji bez ani jednego wolnego mieszkania podświetlamy na szaro, nie na fiolet
    var isFloorZone = area.hasAttribute('data-invest-map-area-floor');
    var floorSoldOut = isFloorZone && Number(area.getAttribute('data-invest-map-count')) === 0;

    var fill = hover || (isBuildingZone ? color : (floorSoldOut ? SOLD_COLOR : FLOOR_HIGHLIGHT));
    var solid = !!hover || isBuildingZone || floorSoldOut;
    var shape = shapeFromComputed(computed);
    shape.setAttribute('class', 'investMapInteractive__hl');
    shape.setAttribute('fill', fill);
    shape.setAttribute('fill-opacity', solid ? '0.5' : '0.35');
    shape.setAttribute('stroke', fill);
    shape.setAttribute('stroke-width', solid ? '1' : '2');
    /* Kolor ma się pojawiać płynnie, a nie skakać - wstawiamy kształt przezroczysty
       i dopiero w następnej klatce włączamy pełną widoczność, żeby przeglądarka
       miała od czego animować przejście (samo dodanie elementu nic nie animuje). */
    shape.style.opacity = '0';
    highlightGroup.appendChild(shape);
    rysujPodpisyStrefy(area, computed);
    requestAnimationFrame(function () {
      shape.style.opacity = '1';
    });
  }

  function clearHighlight() {
    /* Wygaszamy zamiast usuwać od razu - element znika dopiero po przejściu. */
    Array.prototype.forEach.call(highlightGroup.children, function (shape) {
      shape.style.opacity = '0';
      setTimeout(function () {
        if (shape.parentNode === highlightGroup) highlightGroup.removeChild(shape);
      }, HIGHLIGHT_FADE_MS);
    });
  }

  /* Tooltip z danymi mieszkania (Numer/Cena/Metraż/Pokoje/Piętro/Status) - treść
     wyrenderowana po stronie serwera (apartmentTooltip.blade.php), tu tylko
     pokazujemy/pozycjonujemy właściwy fragment przy najechaniu na strefę. */
  var tooltipContainer = mapEl.querySelector('[data-apartment-tooltip]');

  function showApartmentTooltip(apartmentId, evt) {
    if (!tooltipContainer) return;
    var content = tooltipContainer.querySelector('[data-apartment-tooltip-content="' + apartmentId + '"]');
    if (!content) return;

    var display = tooltipContainer.querySelector('[data-apartment-tooltip-display]');
    if (!display) {
      display = document.createElement('div');
      display.setAttribute('data-apartment-tooltip-display', '');
      tooltipContainer.appendChild(display);
    }
    display.innerHTML = content.innerHTML;

    tooltipContainer.removeAttribute('hidden');
    tooltipContainer.style.position = 'absolute';
    tooltipContainer.style.zIndex = '20';
    positionApartmentTooltip(evt);
  }

  function positionApartmentTooltip(evt) {
    if (!tooltipContainer || tooltipContainer.hasAttribute('hidden') || !wrapper) return;
    var wrapperRect = wrapper.getBoundingClientRect();
    tooltipContainer.style.left = (evt.clientX - wrapperRect.left + 12) + 'px';
    tooltipContainer.style.top = (evt.clientY - wrapperRect.top + 12) + 'px';
  }

  /* Ta sama granica co w CSS: od tej szerokości tooltip jest wyśrodkowaną kartą
     z krzyżykiem, a nie chmurką podążającą za kursorem. */
  function dotykowyTooltip() {
    return window.innerWidth <= 1024;
  }

  function hideApartmentTooltip() {
    if (!tooltipContainer) return;
    tooltipContainer.setAttribute('hidden', '');
  }

  if (tooltipContainer) {
    tooltipContainer.addEventListener('click', function (evt) {
      if (evt.target.closest('[data-apartment-tooltip-close]')) {
        clearHighlight();
        hideApartmentTooltip();
      }
    });

    /* Skoro na mobile karta nie znika po zjechaniu kursorem, musi ją zamykać też dotknięcie
       obok - byle nie w samą kartę i nie w strefę na planie (tam otwiera się kolejna). */
    document.addEventListener('click', function (evt) {
      if (!dotykowyTooltip()) return;
      if (tooltipContainer.hasAttribute('hidden')) return;
      if (evt.target.closest('[data-apartment-tooltip]')) return;
      if (evt.target.tagName === 'AREA') return;
      clearHighlight();
      hideApartmentTooltip();
    });
  }

  function bindAreaEvents() {
    currentAreas().forEach(function (area) {
      /* Niedostępne mieszkanie ma tylko tooltip - bez data-href nie ma dokąd kliknąć,
         więc nie udajemy linku kursorem. Niedostępny budynek ("wkrótce w sprzedaży")
         dostaje wprost kursor zakazu, żeby od razu było widać, że tam się nie wejdzie. */
      /* data-floors mają strefy statycznego planu - klik nic nie robi, ale kursor ma być
         ręką, żeby było widać, że strefa reaguje. */
      var clickable = area.getAttribute('data-href') || area.getAttribute('data-invest-map-area-floor') || area.getAttribute('data-invest-map-area-building') || area.getAttribute('data-floors');
      if (clickable) {
        area.style.cursor = 'pointer';
      } else if (area.hasAttribute('data-invest-map-building-zone')) {
        area.style.cursor = 'not-allowed';
      } else {
        area.style.cursor = 'default';
      }
      area.addEventListener('mouseenter', function (evt) {
        highlightArea(area);
        var apartmentId = area.getAttribute('data-apartment-id');
        if (apartmentId) showApartmentTooltip(apartmentId, evt);
        /* Strefa budynku na rzucie osiedla przestawia plakietkę na liczbę wolnych
           mieszkań tego budynku - domyślnie widać tam sumę z całej inwestycji. */
        if (area.hasAttribute('data-invest-map-building-zone')) {
          showCount(area.getAttribute('data-invest-map-count'));
        }

        /* Strefa piętra na elewacji budynku - plakietka pokazuje to piętro i jego liczbę
           wolnych mieszkań, tak samo jak najechanie na piętro na liście obok. Dane bierzemy
           z przycisku tego piętra, żeby liczby były w obu miejscach te same. */
        showBadge(floorButtonFor(area));

        // podświetlenie przycisku w panelu - drugi kierunek tej samej pary strefa <-> przycisk
        if (!highlightFloorButtons(area)) highlightButton(buttonForArea(area));
      });
      area.addEventListener('mousemove', function (evt) {
        if (area.getAttribute('data-apartment-id')) positionApartmentTooltip(evt);
      });
      area.addEventListener('mouseleave', function () {
        clearHighlight();
        clearButtonHighlight();
        /* Na mobile tooltip jest kartą z krzyżykiem i przyciskiem "Zobacz więcej", więc
           zostaje otwarty. Przy dotyku przeglądarka i tak wysyła syntetyczny mouseleave
           zanim dojdzie click - tooltip znikał wtedy przed kliknięciem i wyglądało to tak,
           jakby przycisk tylko zamykał kartę, zamiast prowadzić do mieszkania. */
        if (!dotykowyTooltip()) hideApartmentTooltip();
        if (area.hasAttribute('data-invest-map-building-zone')) showCount(null);
        // po zjechaniu ze strefy piętra plakietka wraca do piętra otwartego na mapie
        if (area.getAttribute('data-invest-map-area-floor')) showBadge(activeFloor);
      });

      area.addEventListener('click', function (e) {
        e.preventDefault();
        var buildingId = area.getAttribute('data-invest-map-area-building');
        if (buildingId) {
          navigateToBuilding(buildingId);
          return;
        }
        var floorId = area.getAttribute('data-invest-map-area-floor');
        if (floorId) {
          /* Numer piętra wprost ze strefy, jeśli go niesie - strefy statycznej elewacji
             mają go u siebie, bo ich knopki są rozrzucone po dwóch kolumnach klatek i nie
             wszystkie da się znaleźć w tej jednej liście. */
          var numer = area.getAttribute('data-invest-map-floor-number');
          if (numer === null) {
            var btn = floorButtonFor(area);
            numer = btn ? btn.getAttribute('data-invest-map-floor-number') : null;
          }
          if (numer !== null) navigateToFloor(numer);
          return;
        }
        /* Kliknięcie strefy mieszkania: przejdź do karty mieszkania w TEJ SAMEJ karcie
           przeglądarki (nie w nowej - stąd window.location.href, a nie window.open). */
        var href = area.getAttribute('data-href');
        if (!href) return;

        /* Na dotyku (do 1024 px, ta sama granica co karta tooltipa) dotknięcie strefy NIE
           przenosi od razu na stronę mieszkania - najpierw pokazuje kartę z danymi, a do
           mieszkania prowadzi dopiero jej przycisk "Zobacz więcej". Palcem nie da się
           "najechać", więc bez tego jedno dotknięcie robiło i hover, i klik: karta ledwo
           mrugała, przeglądarka szła na stronę mieszkania, a przycisk w karcie był
           nieosiągalny. Podświetlenie odtwarzamy, bo przy dotyku przeglądarka wysyła
           syntetyczny mouseleave (a ten je gasi) jeszcze przed clickiem.
           Na desktopie zostaje stare zachowanie: hover pokazuje chmurkę, klik przenosi. */
        var apartmentId = area.getAttribute('data-apartment-id');
        if (dotykowyTooltip() && apartmentId) {
          highlightArea(area);
          showApartmentTooltip(apartmentId, e);
          return;
        }

        window.location.href = href;
      });
    });
  }

  /* Wybór piętra przełącza URL (?floor[]=X, zachowując inne aktywne filtry) - dzięki temu
     ponowne wygenerowanie strony pokazuje plan wybranego piętra ORAZ automatycznie
     filtruje listę mieszkań poniżej do tego piętra (ten sam parametr co filtr "Piętro",
     który jest multi-selectem stąd format tablicowy floor[] zamiast floor). Kotwica
     #investMapInteractive na końcu sprawia, że po przeładowaniu strona jest od razu
     przewinięta z powrotem do mapy, zamiast zostawiać użytkownika na górze strony. */
  function navigateToFloor(floorNumber) {
    var params = new URLSearchParams(window.location.search);
    params.delete('floor[]');
    params.set('floor[]', floorNumber);
    window.location.href = window.location.pathname + '?' + params.toString() + '#investMapInteractive';
  }

  /* Wybór budynku na rzucie osiedla. Piętro leci do kosza, bo numery pięter są lokalne
     dla budynku - trzymanie starego piętra pokazałoby plan z innego budynku. */
  function navigateToBuilding(buildingId) {
    var params = new URLSearchParams(window.location.search);
    params.delete('floor[]');
    params.set('building', buildingId);
    window.location.href = window.location.pathname + '?' + params.toString() + '#investMapInteractive';
  }

  buildingButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      navigateToBuilding(btn.getAttribute('data-invest-map-area-building'));
    });
  });

  /* Najechanie na przycisk etapu/budynku w panelu po prawej podświetla odpowiadający mu
     budynek na rzucie - i odwrotnie niż klik, działa też dla niedostępnych (stąd osobne
     data-invest-map-building-id, a nie data-invest-map-area-building, którego one nie mają). */
  mapEl.querySelectorAll('button[data-invest-map-building-id]').forEach(function (btn) {
    var id = btn.getAttribute('data-invest-map-building-id');
    var area = mapEl.querySelector('area[data-invest-map-building-id="' + id + '"]');
    if (!area) return;

    /* Ten sam odczyt co po najechaniu na strefę - przycisk i strefa to dwa wejścia do
       tego samego budynku, więc plakietka ma pokazywać w obu przypadkach to samo. */
    function enter() {
      highlightArea(area);
      showCount(btn.getAttribute('data-invest-map-count'));
    }

    function leave() {
      clearHighlight();
      showCount(null);
    }

    btn.addEventListener('mouseenter', enter);
    btn.addEventListener('mouseleave', leave);
    btn.addEventListener('focus', enter);
    btn.addEventListener('blur', leave);
  });

  floorButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      navigateToFloor(btn.getAttribute('data-invest-map-floor-number'));
    });

    btn.addEventListener('mouseenter', function () {
      showBadge(btn);
    });

    btn.addEventListener('mouseleave', function () {
      showBadge(activeFloor);
    });
  });

  /* Elementy listy pięter, w kolejności DOM. */
  function floorItems(list) {
    return list.querySelectorAll('.investMapInteractive__floor');
  }

  /* Lista jest kolumną na desktopie i poziomym paskiem na mobile. */
  function listaPoziomo(list) {
    return getComputedStyle(list).flexDirection.indexOf('row') === 0;
  }

  /* Na mobile pasek nie jest przewijany, tylko obracany w pętli: przy "dalej" pierwsza
     pozycja wędruje na koniec, przy "wstecz" ostatnia na początek. Dzięki temu z każdego
     miejsca da się dojść do dowolnego piętra i nie ma znaczenia, jak dana przeglądarka
     liczy scrollLeft przy odwróconym kierunku (Chrome ujemnie, Safari dodatnio) ani czy
     wyśrodkowana treść pozwala dojechać do obu brzegów. */
  function obrocListe(list, direction) {
    var items = floorItems(list);
    if (items.length < 2) return;

    if (direction > 0) {
      list.appendChild(items[0]);
    } else {
      list.insertBefore(items[items.length - 1], items[0]);
    }
  }

  /* Aktywne piętro ma być widoczne od razu po wejściu. Na desktopie dowozimy je
     przewinięciem kolumny, na mobile obracamy pasek, aż wejdzie w okno - obrotów robimy
     najwyżej tyle, ile jest pozycji, żeby nie kręcić się w kółko. */
  function pokazAktywnePietro() {
    sliders.forEach(function (slider) {
      var list = slider.list;
      var aktywny = list.querySelector('.investMapInteractive__floor--active');
      if (!aktywny) return;

      if (listaPoziomo(list)) {
        /* Widoczne są trzy pozycje, a środkowa z nich to druga w DOM (przy row-reverse
           pierwsza w DOM leży po prawej). Obracamy pasek, aż aktywne piętro trafi na to
           miejsce - czyli na środek. Obrotów nie więcej niż pozycji, żeby nie kręcić w kółko. */
        var items = floorItems(list);
        for (var i = 0; i < items.length; i++) {
          if (list.children[1] === aktywny) return;
          obrocListe(list, 1);
        }
        return;
      }

      var boxV = list.getBoundingClientRect();
      var rV = aktywny.getBoundingClientRect();
      var delta = (rV.top + rV.height / 2) - (boxV.top + boxV.height / 2);
      if (Math.abs(delta) < 1) return;

      /* Lista ma w CSS scroll-behavior: smooth, a to jest stan początkowy - na chwilę
         wyłączamy animację. */
      var zapamietane = list.style.scrollBehavior;
      list.style.scrollBehavior = 'auto';
      list.scrollTop += delta;
      list.style.scrollBehavior = zapamietane;
    });
  }

  sliders.forEach(function (slider) {
    slider.buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var direction = parseInt(btn.getAttribute('data-invest-map-scroll'), 10);

        if (listaPoziomo(slider.list)) {
          obrocListe(slider.list, direction);
          return;
        }

        slider.list.scrollBy({ top: direction * 60, behavior: 'smooth' });
      });
    });
  });

  /* Przesuwanie paska palcem. Pasek nie jest przewijany (ma overflow: hidden, a pozycje
     krążą w pętli - patrz obrocListe), więc gest obsługujemy sami: co SWIPE_KROK pikseli
     ruchu w poziomie obracamy listę o jedną pozycję, czyli dokładnie tak, jakby ktoś
     stuknął w strzałkę. Dzięki temu treść idzie za palcem.

     Gest pionowy zostawiamy przeglądarce (w CSS touch-action: pan-y), żeby dało się
     przewijać stronę palcem położonym na pasku. Po obrocie połykamy najbliższy klik:
     przeglądarka wysyła go na przycisk, który znalazł się pod palcem, i strona uciekłaby
     na plan piętra zamiast zostać na przesuniętym pasku. */
  var SWIPE_KROK = 60;   // kółko 50 px + przerwa 10 px
  var SWIPE_MIN = 10;    // mniejszy ruch to drgnięcie palca przy stuknięciu

  sliders.forEach(function (slider) {
    var startX = null;
    var startY = null;
    var obrocono = 0;

    slider.list.addEventListener('touchstart', function (evt) {
      if (evt.touches.length !== 1) {
        startX = null;
        return;
      }
      startX = evt.touches[0].clientX;
      startY = evt.touches[0].clientY;
      obrocono = 0;
    }, { passive: true });

    slider.list.addEventListener('touchmove', function (evt) {
      if (startX === null || evt.touches.length !== 1) return;
      if (!listaPoziomo(slider.list)) return;

      var dx = evt.touches[0].clientX - startX;
      var dy = evt.touches[0].clientY - startY;

      /* Dopóki gest jest bardziej pionowy niż poziomy, to przewijanie strony - nie ruszamy
         paska i nie zaczynamy się w to mieszać. */
      if (Math.abs(dx) < SWIPE_MIN || Math.abs(dx) <= Math.abs(dy)) return;

      while (Math.abs(dx) >= SWIPE_KROK) {
        obrocListe(slider.list, dx > 0 ? 1 : -1);
        startX += dx > 0 ? SWIPE_KROK : -SWIPE_KROK;
        dx = evt.touches[0].clientX - startX;
        obrocono++;
      }
    }, { passive: true });

    slider.list.addEventListener('touchend', function () {
      startX = null;
    }, { passive: true });

    slider.list.addEventListener('click', function (evt) {
      if (!obrocono) return;
      obrocono = 0;
      evt.stopPropagation();
      evt.preventDefault();
    }, true);
  });

  /* Strzałki mają sens tylko wtedy, gdy pozycje nie mieszczą się w oknie listy. W pętli
     nigdy ich nie wyłączamy - z każdej strony jest gdzie iść. */
  function updateScrollButtons() {
    sliders.forEach(function (slider) {
      if (!slider.buttons.length) return;

      var canScroll = listaPoziomo(slider.list)
        ? slider.list.scrollWidth > slider.list.clientWidth + 1
        : slider.list.scrollHeight > slider.list.clientHeight + 1;

      slider.buttons.forEach(function (btn) {
        btn.disabled = false;
        if (canScroll) {
          btn.removeAttribute('hidden');
        } else {
          btn.setAttribute('hidden', '');
        }
      });
    });
  }

  bindAreaEvents();
  pokazAktywnePietro();
  updateScrollButtons();
  sliders.forEach(function (slider) {
    slider.list.addEventListener('scroll', updateScrollButtons, { passive: true });
  });
  window.addEventListener('resize', function () {
    rescaleAreas();
    pokazAktywnePietro();
    updateScrollButtons();
  });
  if (image.complete) rescaleAreas();
  image.addEventListener('load', rescaleAreas);
});

/* === ulubione start === */
/* Lista ulubionych lokali siedzi w ciasteczku "ulubione" (tablica id w JSON, ważne rok).
   Nic nie leci na serwer - strona /ulubione tylko odczytuje to ciasteczko przy renderowaniu,
   więc lista żyje do wyczyszczenia ciasteczek przez użytkownika. */
(function () {
  var COOKIE = 'ulubione';

  function read() {
    var match = document.cookie.match(/(?:^|;\s*)ulubione=([^;]*)/);
    if (!match) return [];
    try {
      var parsed = JSON.parse(decodeURIComponent(match[1]));
      if (!Array.isArray(parsed)) return [];
      return parsed.map(Number).filter(function (id) { return id > 0; });
    } catch (e) {
      return [];
    }
  }

  function write(ids) {
    var expires = new Date();
    expires.setTime(expires.getTime() + 365 * 24 * 60 * 60 * 1000);
    document.cookie = COOKIE + '=' + encodeURIComponent(JSON.stringify(ids))
      + ';expires=' + expires.toUTCString() + ';path=/;samesite=lax';
  }

  function updateCount(ids) {
    Array.prototype.forEach.call(document.querySelectorAll('.header__wishlist-count'), function (el) {
      el.textContent = ids.length;
    });
  }

  /* O tym, czy widać serce konturowe czy wypełnione, decyduje CSS na podstawie
     aria-pressed (patrz .favHeart w _offerProducts.scss) - tutaj tylko przestawiamy
     ten atrybut i podpowiedź. */
  function paint(button, isActive) {
    button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    button.title = isActive ? 'Lokal jest w ulubionych' : 'Dodaj do ulubionych';
  }

  function refresh() {
    var ids = read();
    updateCount(ids);
    Array.prototype.forEach.call(document.querySelectorAll('[data-apartment-fav]'), function (button) {
      paint(button, ids.indexOf(parseInt(button.getAttribute('data-apartment-fav'), 10)) !== -1);
    });
  }

  /* Chmurka w prawym dolnym rogu (na mobile od lewej), sama znika po TOAST_MS. Element
     tworzymy raz i trzymamy w body - kolejne kliknięcia tylko podmieniają treść i
     restartują animację, dzięki czemu szybkie klikanie nie mnoży chmurek jedna na drugiej. */
  var TOAST_MS = 3000;
  var toastTimer = null;

  function showToast(text) {
    var toast = document.querySelector('.favToast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'favToast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }

    toast.textContent = text;

    /* Bez zdjęcia klasy i wymuszenia przeliczenia layoutu ponowne dodanie tej samej
       klasy nie odtworzyłoby animacji pojawiania się. */
    toast.classList.remove('favToast--visible');
    void toast.offsetWidth;
    toast.classList.add('favToast--visible');

    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('favToast--visible');
    }, TOAST_MS);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('[data-apartment-fav]') : null;
    if (!button) return;

    event.preventDefault();
    var id = parseInt(button.getAttribute('data-apartment-fav'), 10);
    if (!id) return;

    var ids = read();
    var index = ids.indexOf(id);
    var isAdded = index === -1;

    if (isAdded) {
      ids.push(id);
    } else {
      ids.splice(index, 1);
    }

    write(ids);
    /* refresh zamiast ręcznego malowania jednego przycisku - ten sam lokal może mieć
       na stronie więcej niż jedno serduszko (lista + karta), a licznik w nagłówku
       i tak trzeba przeliczyć. */
    refresh();
    showToast(isAdded ? 'Lokal dodany do listy ulubionych' : 'Lokal usunięty z listy ulubionych');
  });

  /* Przycisk "Wyczyść listę ulubionych" na stronie /ulubione. Lista jest renderowana po
     stronie serwera z ciasteczka, ale zamiast przeładowywać stronę tylko przełączamy
     [hidden] na liście i komunikacie - wtedy chmurka z potwierdzeniem zdąży się pokazać. */
  document.addEventListener('click', function (event) {
    var clear = event.target.closest ? event.target.closest('#clearfav') : null;
    if (!clear) return;

    event.preventDefault();
    if (!read().length) return;

    write([]);
    refresh();

    var list = document.querySelector('.favoritesList');
    var empty = document.querySelector('.favoritesEmpty');
    if (list) list.hidden = true;
    if (empty) empty.hidden = false;
    clear.hidden = true;

    showToast('Lista ulubionych została wyczyszczona');
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
/* === ulubione end === */

let formmoduleInitialized = false;
function checkDepend(element){
  var elementId = element.attr('data-formmodule-element');
  var clearDepend = false;
  if($("[data-formmodule-depend='"+elementId+"']").length>0){
    var dependElement = $("[data-formmodule-depend='"+elementId+"']");
    var inputType = element.prop('tagName').toLowerCase();

    if(inputType!="select")
      inputType = element.attr('type');

    var value = false;
    if(inputType == "select"){
      value = element.find('option:selected').val()!="";
    }else if(inputType=="checkbox" || inputType=="radio"){
      value = element.is(':checked');
    }else{
      value = element.val()!="";
    }

    if(inputType=="select")
      element = element.find('option:selected');

    var dependValues = new Array();
    for(var i=0;i<dependElement.length;i++)
      dependValues = dependValues.concat(dependElement.eq(i).attr('data-formmodule-depend-value').split('|'));

    if(value){
      // console.log(inputType);
      // console.log(dependValues);
      // console.log(dependElement);
      // console.log(element.attr('data-value-id'));
      // console.log(dependElement.attr('data-formmodule-depend-value'));
      // console.log(element.val());


      if(inputType=="radio" || inputType=="select" || inputType=="checked"){
        dependElement.css('display','none');
        dependElement.find('[required]').removeAttr('required');
      }

      if(
        (['select','radio','checkbox'].includes(inputType) && dependValues.includes(element.attr('data-value-id')))
          ||
        (dependElement.attr('data-formmodule-depend-value') === element.val())
      ){
          if(element.attr('data-value-id') === undefined){
            dependElement.css('display','block');
            dependElement.find('[data-required]').each(function(i,el){
              if(typeof $(el).attr('data-required') !== "undefined" && parseInt($(el).attr('data-required'))==1)
                $(el).attr('required','required');
              else
                $(el).removeAttr('required');
            });
          }

          var dependValueElement = $("[data-formmodule-depend-value="+element.attr('data-value-id')+"]");
          if(dependValueElement){
              dependValueElement.css('display','flex');
              dependValueElement.find('[data-required]').each(function(i,el){
                if(typeof $(el).attr('data-required') !== "undefined" && parseInt($(el).attr('data-required'))==1)
                  $(el).attr('required','required');
                else
                  $(el).removeAttr('required');
              });
          }

          var dependValueElement = $("[data-formmodule-depend-value^='"+element.attr('data-value-id')+"|']");
          if(dependValueElement){
              dependValueElement.css('display','flex');
              dependValueElement.find('[data-required]').each(function(i,el){
                if(typeof $(el).attr('data-required') !== "undefined" && parseInt($(el).attr('data-required'))==1)
                  $(el).attr('required','required');
                else
                  $(el).removeAttr('required');
              });
          }

          var dependValueElement = $("[data-formmodule-depend-value*='|"+element.attr('data-value-id')+"|']");
          if(dependValueElement){
              dependValueElement.css('display','flex');
              dependValueElement.find('[data-required]').each(function(i,el){
                if(typeof $(el).attr('data-required') !== "undefined" && parseInt($(el).attr('data-required'))==1)
                  $(el).attr('required','required');
                else
                  $(el).removeAttr('required');
              });
          }

          var dependValueElement = $("[data-formmodule-depend-value$='|"+element.attr('data-value-id')+"']");
          if(dependValueElement){
              dependValueElement.css('display','flex');
              dependValueElement.find('[data-required]').each(function(i,el){
                if(typeof $(el).attr('data-required') !== "undefined" && parseInt($(el).attr('data-required'))==1)
                  $(el).attr('required','required');
                else
                  $(el).removeAttr('required');
              });
          }
      }else{
        if(element.attr('data-value-id') === undefined){
          dependElement.css('display','none');
          dependElement.find('[required]').removeAttr('required');
        }

        var dependValueElement = $("[data-formmodule-depend-value="+element.attr('data-value-id')+"]");
        clearDepend = true;
        if(dependValueElement){
          dependValueElement.css('display','none');
          dependValueElement.find('[required]').removeAttr('required');
        }

        var dependValueElement = $("[data-formmodule-depend-value^='"+element.attr('data-value-id')+"|']");
        if(dependValueElement){
          dependValueElement.css('display','none');
          dependValueElement.find('[required]').removeAttr('required');
        }

        var dependValueElement = $("[data-formmodule-depend-value*='|"+element.attr('data-value-id')+"|']");
        if(dependValueElement){
          dependValueElement.css('display','none');
          dependValueElement.find('[required]').removeAttr('required');
        }

        var dependValueElement = $("[data-formmodule-depend-value$='|"+element.attr('data-value-id')+"']");
        if(dependValueElement){
          dependValueElement.css('display','none');
          dependValueElement.find('[required]').removeAttr('required');
        }
      }
    }else{
      var dependValueElement = $("[data-formmodule-depend-value="+element.attr('data-value-id')+"]");
      if(dependValueElement){
        dependValueElement.css('display','none');
        dependValueElement.find('[required]').removeAttr('required');
      }

      var dependValueElement = $("[data-formmodule-depend-value^='"+element.attr('data-value-id')+"|']");
      if(dependValueElement){
        dependValueElement.css('display','none');
        dependValueElement.find('[required]').removeAttr('required');
      }

      var dependValueElement = $("[data-formmodule-depend-value*='|"+element.attr('data-value-id')+"|']");
      if(dependValueElement){
        dependValueElement.css('display','none');
        dependValueElement.find('[required]').removeAttr('required');
      }

      var dependValueElement = $("[data-formmodule-depend-value$='|"+element.attr('data-value-id')+"']");
      if(dependValueElement){
        dependValueElement.css('display','none');
        dependValueElement.find('[required]').removeAttr('required');
      }
    }

    if(clearDepend){
      if(dependElement.find('select').length>0){
        //dependElement.find('select').prop('selectedIndex', -1);
        dependElement.find('select').val('');
      }else if(dependElement.find('input[type="radio"]').length>0 || dependElement.find('input[type="checkbox"]').length>0){
        dependElement.find('input').prop('checked', false);
      }else{
        dependElement.find('input').val('');
        dependElement.find('textarea').val('');
      }
      dependElement.find('select').trigger('change');
      dependElement.find('input').trigger('keyup');
      dependElement.find('input').trigger('change');
      dependElement.find('textarea').trigger('change');
    }else if(dependElement.length>1){
      if(formmoduleInitialized){
        setTimeout(function(){
          for(var i=0; i< dependElement.length;i++){
            if(!dependElement.eq(i).is(':visible'))
              if(dependElement.eq(i).find('select').length>0){
                // dependElement.eq(i).find('select').prop('selectedIndex', -1);
                dependElement.find('select').val('');
              }else if(dependElement.eq(i).find('input[type="radio"]').length>0 || dependElement.eq(i).find('input[type="checkbox"]').length>0){
                dependElement.eq(i).find('input').prop('checked', false);
              }else{
                dependElement.eq(i).find('input').val('');
                dependElement.eq(i).find('textarea').val('');
              }
              dependElement.eq(i).find('select').trigger('change');
              dependElement.eq(i).find('input').trigger('keyup');
              dependElement.eq(i).find('input').trigger('change');
              dependElement.eq(i).find('textarea').trigger('change');
          }
        },800);
      }
    }
  }
}

function checkMsg(element){
  var msg = element.attr('data-choose-msg');
  element.closest('[data-form-row]').find('.formErrors').css('display','none');

  var inputType = element.prop('tagName').toLowerCase();
  if(inputType!="select" && inputType!="option")
    inputType = element.attr('type');
  var used = false, value = "";
  if(inputType == "select" || inputType == "option"){
    used = element.is(':checked')
    value = element.val();
  }else if(inputType=="checkbox" || inputType=="radio"){
    used = $("#"+element.attr('id')).is(':checked');
    value = element.val();
  }else{
    used = true;
    value = element.val();
  }

  if(used && value!=""){
    if(typeof msg !== "undefined" && msg!=""){
      element.closest('[data-form-row]').find('.formErrors li').html(msg);
      element.closest('[data-form-row]').find('.formErrors').css('display','block');
    }

    if(
        (typeof element.attr('data-formmodule-minvalue')!=="undefined" && value!="" && typeof element.attr('data-formmodule-minvaluemsg')!=="undefined" && element.attr('data-formmodule-minvaluemsg')!="")
        ||
        (inputType=="option" && typeof element.closest('select[data-formmodule-element]').attr('data-formmodule-minvalue')!=="undefined" && value!="" && typeof element.closest('select[data-formmodule-element]').attr('data-formmodule-minvaluemsg')!=="undefined" && element.attr('data-formmodule-minvaluemsg')!="")
    ){
      var showMsg = false, messages = typeof element.attr('data-formmodule-minvaluemsg')!=="undefined" ? element.attr('data-formmodule-minvaluemsg').split('|') : [];
      if(inputType=="date" || element.attr('data-formmodule-element-type')=="date"){
        minDates = element.attr('data-formmodule-minvalue').split('|');
        if(value.indexOf('.')!==-1)
          inputValue = value.split('.');
        else
          inputValue = value.split('-');
        inputValue = inputValue[2]+"-"+inputValue[1]+"-"+inputValue[0];
        inputDate = new Date(inputValue);
        inputDate.setHours(0,0,0);
        for(var i=0;i<minDates.length;i++){
          minDate = minDates[i];
          if(minDate.indexOf('.')!==-1)
            minDate = minDate.split('.');
          else
            minDate = minDate.split('-');
          minDate = minDate[2]+"-"+minDate[1]+"-"+minDate[0];
          minDate = new Date(minDate);
          minDate.setHours(0,0,0);
          if(inputDate<minDate){
            msg = messages[i];
            showMsg = true;
            break;
          }
        }
      }else if(inputType=="month"|| element.attr('data-formmodule-element-type')=="month"){
        minDates = element.attr('data-formmodule-minvalue').split('|');
        inputDate = new Date(value+'-01');
        inputDate.setHours(0,0,0);
        for(var i=0;i<minDates.length;i++){
          minDate = minDates[i];
          minDate = minDate.split('-');
          minDate = new Date(minDate);
          minDate.setHours(0,0,0);

          if(inputDate<minDate){
            msg = messages[i];
            showMsg = true;
            break;
          }
        }
      }else if(inputType=="number"){
        mins = element.attr('data-formmodule-minvalue').split('|');
        for(var i=0;i<mins.length;i++){
          if(value<parseFloat(mins[i])){
            msg = messages[i];
            showMsg = true;
            break;
          }
        }
      }else if(inputType=="option"){
        mins = element.closest('select[data-formmodule-element]').attr('data-formmodule-minvalue').split('|');
        for(var i=0;i<mins.length;i++){
         if(value<mins[i]){
           showMsg = true;
           msg = messages[i];
           break;
         }
       }
      }else{
        mins = element.attr('data-formmodule-minvalue').split('|');
        for(var i=0;i<mins.length;i++){
          if(value<mins[i]){
            showMsg = true;
            msg = messages[i];
            break;
          }
        }
      }

      if(showMsg){
        if(typeof msg !== "undefined" && msg!=""){
          element.closest('[data-form-row]').find('.formErrors li').html(msg);
          element.closest('[data-form-row]').find('.formErrors').css('display','block');
        }
      }
    }

    showMsg = false;
    messages = typeof element.attr('data-formmodule-maxvaluemsg')!=="undefined" ? element.attr('data-formmodule-maxvaluemsg').split('|') : [];
    if(
        (typeof element.attr('data-formmodule-maxvalue')!=="undefined" && value!="" && typeof element.attr('data-formmodule-maxvaluemsg')!=="undefined" && element.attr('data-formmodule-maxvaluemsg')!="")
        ||
        (inputType=="option" && typeof element.closest('select[data-formmodule-element]').attr('data-formmodule-maxvalue')!=="undefined" && value!="" && typeof element.closest('select[data-formmodule-element]').attr('data-formmodule-maxvaluemsg')!=="undefined" && element.attr('data-formmodule-maxvaluemsg')!="")
    ){
      var showMsg = false;
      if(inputType=="date" || element.attr('data-formmodule-element-type')=="date"){
        maxDates = element.attr('data-formmodule-maxvalue').split('|');
        if(value.indexOf('.')!==-1)
          inputValue = value.split('.');
        else
          inputValue = value.split('-');
        inputValue = inputValue[2]+"-"+inputValue[1]+"-"+inputValue[0];
        inputDate = new Date(inputValue);
        inputDate.setHours(0,0,0);

        for(var i=0;i<maxDates.length;i++){
          maxDate = maxDates[i];
          maxDate = minDates[i];
          if(maxDate.indexOf('.')!==-1)
            maxDate = maxDate.split('.');
          else
            maxDate = maxDate.split('-');
          maxDate = maxDate[2]+"-"+maxDate[1]+"-"+maxDate[0];

          maxDate = new Date(maxDate);
          maxDate.setHours(0,0,0);

          if(inputDate>maxDate){
            msg = messages[i];
            showMsg = true;
            break;
          }
        }
      }else if(inputType=="month"|| element.attr('data-formmodule-element-type')=="month"){
        maxDates = element.attr('data-formmodule-maxvalue').split('|');
        inputDate = new Date(value+'-01');
        inputDate.setHours(0,0,0);

        for(var i=0;i<maxDates.length;i++){
          maxDate = maxDates[i];
          maxDate = new Date(maxDate);
          maxDate.setHours(0,0,0);
          if(inputDate>maxDate){
            msg = messages[i];
            showMsg = true;
            break;
          }
        }
      }else if(inputType=="number"){
        maxs = element.attr('data-formmodule-maxvalue').split('|');
        for(var i=0;i<maxs.length;i++){
          if(value>parseFloat(maxs[i])){
            msg = messages[i];
            showMsg = true;
            break;
          }
        }
      }else if(inputType=="option"){
        maxs = element.closest('select[data-formmodule-element]').attr('data-formmodule-maxvalue').split('|');
        for(var i=0;i<maxs.length;i++){
         if(value>maxs[i]){
           showMsg = true;
           msg = messages[i];
           break;
         }
       }
      }else{
        maxs = element.attr('data-formmodule-maxvalue').split('|');
        for(var i=0;i<maxs.length;i++){
          if(value>maxs[i]){
            showMsg = true;
            msg = messages[i];
            break;
          }
        }
      }

      if(showMsg){
        if(typeof msg !== "undefined" && msg!=""){
          element.closest('[data-form-row]').find('.formErrors li').html(msg);
          element.closest('[data-form-row]').find('.formErrors').css('display','block');
        }
      }
    }
  }
}

function init(){
  $("input[data-formmodule-element]").trigger('keyup');
  $("select[data-formmodule-element]").trigger('change');
  $("input[data-formmodule-element]").trigger('change');
  formmoduleInitialized = true;
}

$(document).ready(function(){
  $("select[data-formmodule-element]").on('select2:select', function (e) {
    checkDepend($(this));
    checkMsg($(this).find('option:selected'))
  });
  if($("select[data-formmodule-element]").length>0){
    $("select[data-formmodule-element]").bind('change',function(){
      checkDepend($(this));
      checkMsg($(this));
    });
  }
  $("input[data-formmodule-element]").bind('click',function(){
    checkDepend($(this));
    checkMsg($(this));
  });
  $("input[data-formmodule-element]").bind('change',function(){
    checkDepend($(this));
    checkMsg($(this));
  });
  $("input[data-formmodule-element],textarea[data-formmodule-element]").bind('keyup',function(){
    var el = $(this).parent().find('[data-formmodule-charlimit]');
    if(el.length){
      el.html(parseInt(el.attr('data-formmodule-charlimit')) - $(this).val().length);
    }
  });
  $("select[data-formmodule-monthyear],select[data-formmodule-monthmonth]").on('select2:select',function(){
    var year = $(this).closest("[data-form-row]").find("select[data-formmodule-monthyear]").find('option:selected').val();
    var month = $(this).closest("[data-form-row]").find("select[data-formmodule-monthmonth]").find('option:selected').val();
    $(this).closest("[data-form-row]").find('input[data-formmodule-element]').val(year+"-"+month);
    $(this).closest("[data-form-row]").find('input[data-formmodule-element]').trigger('change');
  });
  // $("input[data-formmodule-element]").bind('keyup',function(){
  //   checkDepend($(this));
  //   checkMsg($(this));
  // });
  $("input[data-formmodule-element][type='checkbox']").bind('change',function(){
    var group = $(this).closest('[data-form-row]');
    var checked = group.find('input:checked').length;
    if(checked>0){
      group.find('input').removeAttr('required');
    }else if(typeof group.attr('required')!="undefined"){
      group.find('input').attr('required','required');
    }
  });
  init();
});



$(".calendar").datepicker({
  format:'dd.mm.yyyy',
  language: $('html').attr('lang'),
  autoclose: true
});



$('input.timepicker').timepicker({
  timeFormat: 'H:mm ',
  interval: 60,
  minTime: '00',
  maxTime: '23',
  startTime: '10:00',
  dynamic: false,
  dropdown: true,
  scrollbar: true
});


var placeholderYears = window.Laravel.lang.forms.yearPlaceholder;
var placeholderMonth = window.Laravel.lang.forms.monthPlaceholder;

$('.monthCalendar__selects-years').select2({
    placeholder: placeholderYears
});

$('.monthCalendar__selects-month').select2({
   placeholder: placeholderMonth
});


  // file input

  const dt = []; // Permet de manipuler les fichiers de l'input file

  $("[data-form-file]").on('change', function(e){
    var elementId = $(this).closest("[data-form-row]").attr("data-form-row");
    if(typeof dt[elementId] === "undefined")
      dt[elementId] = new DataTransfer();

  	for(var i = 0; i < this.files.length; i++){
  		let fileBloc = $('<span/>', {class: 'file-block'}),
  			 fileName = $('<span/>', {class: 'name', text: this.files.item(i).name});
  		fileBloc.append('<span class="file-delete"><span class="iconDel"></span></span>')
  			.append(fileName);
  		$(this).closest(".files").find("#filesList > #files-names").append(fileBloc);
  	};
  	for (let file of this.files) {
  		dt[elementId].items.add(file);
  	}

  	this.files = dt[elementId].files;

  	$('span.file-delete').click(function(){
      var container = $(this).closest("[data-form-row]");
      var elementId = container.attr("data-form-row");

  		let name = $(this).next('span.name').text();
  		$(this).parent().remove();
  		for(let i = 0; i < dt[elementId].items.length; i++){
  			if(name === dt[elementId].items[i].getAsFile().name){
  				dt[elementId].items.remove(i);
  				continue;
  			}
  		}
      container.find('[data-form-file]')[0].files = dt[elementId].files;
  	});
  });

/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-webp-setclasses !*/
 !function(e,n,A){function o(e,n){return typeof e===n}function t(){var e,n,A,t,a,i,l;for(var f in r)if(r.hasOwnProperty(f)){if(e=[],n=r[f],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(A=0;A<n.options.aliases.length;A++)e.push(n.options.aliases[A].toLowerCase());for(t=o(n.fn,"function")?n.fn():n.fn,a=0;a<e.length;a++)i=e[a],l=i.split("."),1===l.length?Modernizr[l[0]]=t:(!Modernizr[l[0]]||Modernizr[l[0]]instanceof Boolean||(Modernizr[l[0]]=new Boolean(Modernizr[l[0]])),Modernizr[l[0]][l[1]]=t),s.push((t?"":"no-")+l.join("-"))}}function a(e){var n=u.className,A=Modernizr._config.classPrefix||"";if(c&&(n=n.baseVal),Modernizr._config.enableJSClass){var o=new RegExp("(^|\\s)"+A+"no-js(\\s|$)");n=n.replace(o,"$1"+A+"js$2")}Modernizr._config.enableClasses&&(n+=" "+A+e.join(" "+A),c?u.className.baseVal=n:u.className=n)}function i(e,n){if("object"==typeof e)for(var A in e)f(e,A)&&i(A,e[A]);else{e=e.toLowerCase();var o=e.split("."),t=Modernizr[o[0]];if(2==o.length&&(t=t[o[1]]),"undefined"!=typeof t)return Modernizr;n="function"==typeof n?n():n,1==o.length?Modernizr[o[0]]=n:(!Modernizr[o[0]]||Modernizr[o[0]]instanceof Boolean||(Modernizr[o[0]]=new Boolean(Modernizr[o[0]])),Modernizr[o[0]][o[1]]=n),a([(n&&0!=n?"":"no-")+o.join("-")]),Modernizr._trigger(e,n)}return Modernizr}var s=[],r=[],l={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var A=this;setTimeout(function(){n(A[e])},0)},addTest:function(e,n,A){r.push({name:e,fn:n,options:A})},addAsyncTest:function(e){r.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=l,Modernizr=new Modernizr;var f,u=n.documentElement,c="svg"===u.nodeName.toLowerCase();!function(){var e={}.hasOwnProperty;f=o(e,"undefined")||o(e.call,"undefined")?function(e,n){return n in e&&o(e.constructor.prototype[n],"undefined")}:function(n,A){return e.call(n,A)}}(),l._l={},l.on=function(e,n){this._l[e]||(this._l[e]=[]),this._l[e].push(n),Modernizr.hasOwnProperty(e)&&setTimeout(function(){Modernizr._trigger(e,Modernizr[e])},0)},l._trigger=function(e,n){if(this._l[e]){var A=this._l[e];setTimeout(function(){var e,o;for(e=0;e<A.length;e++)(o=A[e])(n)},0),delete this._l[e]}},Modernizr._q.push(function(){l.addTest=i}),Modernizr.addAsyncTest(function(){function e(e,n,A){function o(n){var o=n&&"load"===n.type?1==t.width:!1,a="webp"===e;i(e,a&&o?new Boolean(o):o),A&&A(n)}var t=new Image;t.onerror=o,t.onload=o,t.src=n}var n=[{uri:"data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=",name:"webp"},{uri:"data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==",name:"webp.alpha"},{uri:"data:image/webp;base64,UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA",name:"webp.animation"},{uri:"data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=",name:"webp.lossless"}],A=n.shift();e(A.name,A.uri,function(A){if(A&&"load"===A.type)for(var o=0;o<n.length;o++)e(n[o].name,n[o].uri)})}),t(),a(s),delete l.addTest,delete l.addAsyncTest;for(var p=0;p<Modernizr._q.length;p++)Modernizr._q[p]();e.Modernizr=Modernizr}(window,document);
$(document).ready(function(){

  $('.wcagIconMobile').on("click", function () {
      $('.wcag').toggleClass('active')
  });

  if(typeof sessionStorage["fontsize"] === "undefined")
    sessionStorage['fontsize'] = 0;

  var size = 0;
  $('.wcagFontsMinus').on("click", function () {
    if(size>-3 || size == 0){
      if ('sessionStorage' in window && typeof sessionStorage == 'object')
        sessionStorage["fontsize"] = parseInt(sessionStorage["fontsize"]) - 1;
      $('*').each(function(){
        $(this).css('font-size', parseInt($(this).css('font-size')) - 1);
      });
      size--;
    }
  });
  $('.wcagFontsPlus').on("click", function () {
    if(size<6){
      if ('sessionStorage' in window && typeof sessionStorage == 'object')
        sessionStorage["fontsize"] = parseInt(sessionStorage["fontsize"]) + 1;
      $('*').each(function(){
        $(this).css('font-size', parseInt($(this).css('font-size')) + 1);
      });
      size++;
    }
  });

  $('.wcagFontsReset').on("click", function () {
    sessionStorage['fontsize'] = 0;
    $('*').each(function(){
      $(this).css('font-size','');
    });
    size = 0;
  });





  $('#wcagContrast-yellowBlack').on("click", function () {
    $('body').removeClass('blackYellow');
    $('body').removeClass('blackWhite');
    $('body').removeClass('gray');
    $('body').addClass('yellowBlack');
    $('.wcagContrastReset').removeClass('active');
    $('.wcagContrastGray ').removeClass('active');

    if ('sessionStorage' in window && typeof sessionStorage == 'object') {
      sessionStorage["blackYellow"] = 0;
      sessionStorage["blackWhite"] = 0;
      sessionStorage["gray"] = 0;
      sessionStorage["yellowBlack"] = 1;
    }
  });


  $('#wcagContrast-blackYellow').on("click", function () {
    $('body').removeClass('yellowBlack');
    $('body').removeClass('blackWhite');
    $('body').removeClass('gray');
    $('body').addClass('blackYellow');
    $('.wcagContrastReset').removeClass('active');
    $('.wcagContrastGray ').removeClass('active');

    if ('sessionStorage' in window && typeof sessionStorage == 'object') {
      sessionStorage["blackYellow"] = 1;
      sessionStorage["blackWhite"] = 0;
      sessionStorage["gray"] = 0;
      sessionStorage["yellowBlack"] = 0;
    }
  });


  $('#wcagContrast-blackWhite').on("click", function () {
    $('body').removeClass('yellowBlack');
    $('body').removeClass('gray');
    $('body').removeClass('blackYellow');
    $('body').addClass('blackWhite');
    $('.wcagContrastReset').removeClass('active');
    $('.wcagContrastGray ').removeClass('active');

    if ('sessionStorage' in window && typeof sessionStorage == 'object') {
      sessionStorage["blackYellow"] = 0;
      sessionStorage["blackWhite"] = 1;
      sessionStorage["gray"] = 0;
      sessionStorage["yellowBlack"] = 0;
    }
  });

  $('#wcagContrast-gray').on("click", function () {
    $('body').removeClass('yellowBlack');
    $('body').removeClass('blackWhite');
    $('body').removeClass('blackYellow');
    $('body').addClass('gray');
    $(this).addClass('active');
    $('.wcagContrastReset').removeClass('active');

    

    if ('sessionStorage' in window && typeof sessionStorage == 'object') {
      sessionStorage["blackYellow"] = 0;
      sessionStorage["blackWhite"] = 0;
      sessionStorage["gray"] = 1;
      sessionStorage["yellowBlack"] = 0;
    }
  });

  $('#wcagContrast-reset').on("click", function () {
    sessionStorage["blackYellow"] = 0;
    sessionStorage["blackWhite"] = 0;
    sessionStorage["gray"] = 0;
    sessionStorage["yellowBlack"] = 0;
    $('body').removeClass();
        $(this).addClass('active');
    $('.wcagContrastGray ').removeClass('active');
  });





    // Check if sessionStorage is supported
      if ('sessionStorage' in window && typeof sessionStorage == 'object') {
          if(parseInt(sessionStorage["fontsize"])!=0){
            var elements = $('*');
            var sizes = [];
            for(var i=0;i<elements.length;i++)
                sizes[i] = parseInt(elements.eq(i).css('font-size')) + parseInt(sessionStorage['fontsize']);
            for(var i=0;i<elements.length;i++)
              elements.eq(i).css('font-size', sizes[i]);
          }
          size = parseInt(sessionStorage['fontsize']);

          ["blackYellow","blackWhite","gray","yellowBlack"].forEach(function(element){
            if(parseInt(sessionStorage[element])==1){
              $('body').removeClass();
              $('#wcagContrast-'+element).trigger('click');
            }
          });
      }

      });

const dataTransfer = new DataTransfer(); // Allows you to manipulate files in the input file

$(".classInputFile").on('change', function(e){
	for(var i = 0; i < this.files.length; i++){
		let fileBloc = $('<span/>', {class: 'file-block'}),
			 fileName = $('<span/>', {class: 'name', text: this.files.item(i).name});
		fileBloc.append('<span class="file-delete"><span class="iconDel"></span></span>')
			.append(fileName);
		$(".filesList > .files-names").append(fileBloc);
	};
	// Adding files to the DataTransfer object
	for (let file of this.files) {
		dataTransfer.items.add(file);
	}
	// Update input file files after adding
	this.files = dataTransfer.files;

	// EventListener for the created delete button
	$('span.file-delete').click(function(){
		let name = $(this).next('span.name').text();
		// Remove file name display
		$(this).parent().remove();
		for(let i = 0; i < dataTransfer.items.length; i++){
			// File and name matching
			if(name === dataTransfer.items[i].getAsFile().name){
				// Deleting file in DataTransfer object
				dataTransfer.items.remove(i);
				continue;
			}
		}
		//Updating input file files after deletion
			$(this).cloest('.files').find('input')[0].files = dataTransfer.files
	});
});

$(document).ready(function(){



  var selectPlaceholder = window.Laravel.lang.forms.selectPlaceholder;

  $('.select').select2({
     placeholder: selectPlaceholder,
     minimumResultsForSearch: Infinity, // hide search field,
     language: {
       "noResults": function(){
           return window.Laravel.lang.empty_select;
       }
     }
  });
$('.js-multiselect').select2({
    placeholder: 'Wybierz',
    allowClear: false,
    minimumResultsForSearch: Infinity,
     theme: 'default multipleContainerDropdown',
    multiple: true,
    closeOnSelect: false,
    language: {
        "noResults": function(){
            return window.Laravel.lang.empty_select;
        }
    }
});

  function updateMultiselectSummary($el) {
    var count = ($el.val() || []).filter(function (v) { return v !== '' && v !== null; }).length;
    var $rendered = $el.next('.select2-container').find('.select2-selection__rendered');
    if (count > 0) {
      $rendered.html('<li class="select2-selection__choice select2-selection__choice--count">Wybrano: ' + count + '</li>');
    }
  }

  $('.js-multiselect').each(function () {
    updateMultiselectSummary($(this));
  });

  $('.js-multiselect').on('change', function () {
    updateMultiselectSummary($(this));
  });

  $('.select').on('change', function () {
        $(this).valid();
  });
  $(".select-search").select2({
    //minimumResultsForSearch: 0,
    language: {
      "noResults": function(){
        return window.Laravel.lang.empty_select;
      }
    },
    matcher: function(params, data) {
        if ($.trim(params.term) === '')
          return data;

        if (typeof data.text === 'undefined')
          return null;

        if (data.text.toLowerCase().indexOf(params.term.toLowerCase()) > -1) {
          var modifiedData = $.extend({}, data, true);
          //modifiedData.text += ' (matched)';
          return modifiedData;
        }

        return null;
    },
    templateSelection: function(data) {
      // if(data.selected) //nie wybiera po kliku lub enterze po wyszukiwaniu
        return data.text.trim();
    },
    tokenSeparators: [',', ' ']
  });


  var sortPlaceholder = window.Laravel.lang.offer.sort;

  $('#sortProducts').select2({
      placeholder: sortPlaceholder,
      minimumResultsForSearch: Infinity // hide search field
  });



  $(".filtrPrice .mutliSelect__name").on('click', function() {
    $(".filtrPrice ul").slideToggle('fast');
    $(".filtrColor ul").hide();
    $(".filtrQuality ul").hide();
    $(".filtrSort ul").hide();

  });

  $(".filtrColor .mutliSelect__name").on('click', function() {
    $(".filtrColor ul").slideToggle('fast');
    $(".filtrQuality ul").hide();
    $(".filtrSort ul").hide();
    $(".filtrPrice ul").hide();
  });
  $(".filtrQuality .mutliSelect__name").on('click', function() {
    $(".filtrQuality ul").slideToggle('fast');
    $(".filtrColor ul").hide();
    $(".filtrSort ul").hide();
    $(".filtrPrice ul").hide();


  });
  $(".filtrSort .mutliSelect__name").on('click', function() {
    $(".filtrSort ul").slideToggle('fast');
    $(".filtrColor ul").hide();
    $(".filtrQuality ul").hide();
    $(".filtrPrice ul").hide();

  });

  $(document).bind('click', function(e) {
    var $clicked = $(e.target);
    if (!$clicked.parents().hasClass("mutliSelectWrap")) $(".mutliSelectWrap ul").hide();
  });



});

!function(a){a.fn.datepicker.dates.pl={
  days:["Niedziela","Poniedziałek","Wtorek","Środa","Czwartek","Piątek","Sobota"],
  daysShort:["Niedz.","Pon.","Wt.","Śr.","Czw.","Piąt.","Sob."],
  daysMin:["Ndz.","Pn.","Wt.","Śr.","Czw.","Pt.","Sob."],
  months:["Styczeń","Luty","Marzec","Kwiecień","Maj","Czerwiec","Lipiec","Sierpień","Wrzesień","Październik","Listopad","Grudzień"],
  monthsShort:["Sty.","Lut.","Mar.","Kwi.","Maj","Cze.","Lip.","Sie.","Wrz.","Paź.","Lis.","Gru."],
  today:"Dzisiaj",
  weekStart:1,
  clear:"Wyczyść",
  format:"dd.mm.yyyy"}
}(jQuery);

$(document).ready(function(){

  $(".calendar").datepicker({
    format:'dd.mm.yyyy',
    language: 'pl-PL',
    autoclose: true
  });


  $('.timepicker').timepicker({
    timeFormat: 'H:mm ',
    interval: 60,
    minTime: '00',
    maxTime: '23',
    startTime: '10:00',
    dynamic: false,
    dropdown: true,
    scrollbar: true
  });

});

function initFormValidation(selector) {
    $(selector).each(function () {
        const $form = $(this);

        $form.validate({
            ignore: [],

            errorPlacement: function (error, element) {
                if (element.attr('type') === 'file') {
                    error.insertAfter(element.closest('.styledFormItems--files'));
                } else if (element.closest('.wrapcheckbox').length) {
                    error.insertAfter(element.closest('.wrapcheckbox'));
                } else if (
                    typeof element.attr('data-formmodule-monthyear') !== 'undefined' ||
                    typeof element.attr('data-formmodule-monthmonth') !== 'undefined'
                ) {
                    error.insertAfter(element.parent().find('.select2-container'));
                } else {
                    error.insertAfter(element);
                }
            },

            highlight: function (element) {
                $(element).closest('.styledForm__row').addClass('has-error');
            },

            unhighlight: function (element) {
                $(element).closest('.styledForm__row').removeClass('has-error');
            },

            onfocusout: function (element) {
                $(element).valid();
            }
        });

        $form.find('input[type="file"]').on('change', function () {
            const input = this;
            if (input.files && input.files.length > 0) {
                $(input).valid();
            } else {
                $form.validate().element(input);
            }
        });
    });
}

$('form[id^="moduleForm"]').each(function () {
    initFormValidation(this);
});

initFormValidation('#contactForm');
initFormValidation('#contactPopupForm');
/* Starsze Safari (iOS przed 15.4) nie zna scrollTo/scrollBy z obiektem opcji - wywołanie
   jest wtedy po cichu ignorowane, a skoro klik na anchorze robimy preventDefault, to nie
   działo się nic. Dlatego zawsze sprawdzamy wsparcie i w razie braku przewijamy bez
   animacji, starym dwuargumentowym wywołaniem. */
function plynnyScrollWspierany() {
  return 'scrollBehavior' in document.documentElement.style;
}

function przewinStrone(top) {
  if (plynnyScrollWspierany()) {
    window.scrollTo({ top: top, behavior: 'smooth' });
  } else {
    window.scrollTo(0, top);
  }
}

function przewinWBok(element, left) {
  if (plynnyScrollWspierany()) {
    element.scrollTo({ left: left, behavior: 'smooth' });
  } else {
    element.scrollLeft = left;
  }
}
$(document).ready(function(){

  $('.header__login-withSubmenu').on('click', function(){
      $('.header__login-submenu').slideToggle(300);
  });

  $('.myAcc').on('click', function(){
      event.preventDefault();
  });


  //  obcicnanie dlugiego textu w opisie blogu

  $(".blogItem__desc").text(function(i, text) {
    if (text.length >= 165) {
      text = text.substring(0, 165);
      var lastIndex = text.lastIndexOf(" ");
      text = text.substring(0, lastIndex) + '...';
    }
    $(this).text(text);

  });


  /* anchor animate - obsługa delegowana na dokumencie, nie po jednym linku. Przyklejony
     pasek nawigacji inwestycji jest klonem (cloneNode nie kopiuje słuchaczy), więc klik
     w jego pozycje wykonywał domyślny skok przeglądarki, bez animacji.
     Odejmujemy wysokość nagłówka i przyklejonego paska, inaczej początek sekcji chowa się
     pod nimi. */
  document.addEventListener('click', function (e) {
    var anchor = e.target.closest ? e.target.closest('a[href^="#"]') : null;
    if (!anchor) return;

    var href = anchor.getAttribute('href');
    if (!href || href.length < 2) return;

    var target = null;
    try {
      target = document.querySelector(href);
    } catch (err) {
      return;
    }
    if (!target) return;

    e.preventDefault();

    /* Wysokość paska bierzemy z oryginału w układzie, a nie z przyklejonego klonu - klon
       bywa display: none (wtedy offsetHeight to 0), a po przewinięciu i tak zakryje
       górę sekcji. */
    var header = document.querySelector('.js-header');
    var investNav = document.querySelector('.investPageHeader .investPage__nav');
    var offset = (header ? header.offsetHeight : 0) + (investNav ? investNav.offsetHeight : 0);

    przewinStrone(Math.max(0, target.getBoundingClientRect().top + window.pageYOffset - offset));
  });

  if ( $(".mfi").length ) {
      $(".mfi").magnificPopup({
          mainClass: 'mfp-with-zoom',
          removalDelay: 400,
          type: "inline"
      });
  }

  //  hide/show password

  $('body').on('click', '.password-control', function(){
    if ($('#password').attr('type') == 'password'){
    $(this).addClass('view');
    $('#password').attr('type', 'text');
    } else {
    $(this).removeClass('view');
    $('#password').attr('type', 'password');
    }
    return false;
  });

  $('body').on('click', '.password-confirmation-control', function(){
    if ($('#password_confirmation').attr('type') == 'password'){
    $(this).addClass('view');
    $('#password_confirmation').attr('type', 'text');
    } else {
    $(this).removeClass('view');
    $('#password_confirmation').attr('type', 'password');
    }
    return false;
  });


  //if Sidebar exists
  // if ( $('.main__sidebar').length ) {
  //   $('.offerBoxes').addClass('offerBoxes--withSidebar');
  // }

  // go to form message
  if ( $('.formErrors__item').length ) {
    $('html, body').animate({
        scrollTop:  $('.formErrors__item').first().offset().top - 200
    }, 600);
  }

  //language - select
  if ($('.languageBox__select').length) {
    $('.languageBox__select').on('click', function() {
        $('.languageBox__list').toggleClass('visible');


        return false;
    });
  }

  //aos
  if ( $('[data-aos]').length ) {
      AOS.init({
          offset: 50,
          duration: 500
      });
  }

  // lazy loads elements with default selector as '.lozad'
  if ($('.lozad').length) {
    const observer = lozad();
    observer.observe();
  }

  // Handle Lazy loading on page print
  window.onbeforeprint = function() {
    $('.lozad').each(function() {
      var src = $(this).attr('data-src');
      $(this).attr('src', src).parent().addClass('loaded');
    });
  };

  // scrolled menu
  if ($(window).width()<1240){
          $('.js-header').addClass('header--scrolled');
  } else {
      $('.js-header').removeClass('header--scrolled');
  }

  // relax init
  if ($('.rellax').length) {
      var rellax = new Rellax('.rellax', {
        wrapper: '.rellax-parent',
        relativeToWrapper: true,
      });
  }

  // js-up
  $(".js-up").on("click", function () {
      var body = $("html, body");
      body.stop().animate({scrollTop: 0}, 1500, 'swing');
  });


  //go to map
  if ($('.js-gotomap').length) {
    $('.js-gotomap').on('click', function(){
        let anchor = $('.contact__map');
        if (anchor.length) {
            $('html, body').animate({
                scrollTop:  $(anchor).offset().top - 100
            }, 600);
            return false;
        }
    });
  }

  // scrolled menu
  if ($(window).scrollTop() > 0){
    $('.js-header').addClass('header--scrolled');
   } else {
    if ($(window).width()>1240){
      $('.js-header').removeClass('header--scrolled');
    }
  }


  //search
  $('.js-header__search').on('click', function(){
      $('.header .searchBox').slideToggle(300);
  });
  $('.header .searchBox .searchBox__close').on('click', function(){
      $('.header .searchBox').slideToggle(300);
  });

  $('.searchBoxIcon').on('click', function(){
    $('[data-search-form]').submit();
  });

  //filters in offer
  if ($("[data-filter-submit]").length) {
    $("[data-filter-submit]").click(function(){
      var filters = $("[data-filter]"),name,value,counter=1,type;
      var url = top.location.href.split(",");
      var checkedFilters = new Array();
      var filterOperators = [];
      url = url[0]+",1&";
      for(var i=0;i<filters.length;i++){
        id = filters.eq(i).attr('data-filter');
        name = filters.eq(i).attr('data-filter-field');
        type = filters.eq(i).attr('type');
        operator = filters.eq(i).attr('data-filter-operator');
        if(typeof operator === "undefined") operator = "";

        if (!filterOperators.includes(name+"_"+operator)) {
          value = "";
          if($("[data-filter='"+id+"']").length>1){ //&& type!="number") {
            var subFilters = $("[data-filter-field='"+name+"']");
            for(var j=0;j<subFilters.length;j++){
              if(type=="checkbox"){
                value+= subFilters.eq(j).is(":checked") ? subFilters.eq(j).val()+"," : "";
              }else if(subFilters.eq(j).val()!=""){
                value+= subFilters.eq(j).val()+",";
              }
            }
            if(value[value.length-1] == ","){
              value = value.slice(0,-1);
            }
          }else if(type=="checkbox"){
            value = filters.eq(i).is(":checked") ? filters.eq(i).val() : "";
          }else{
            value = filters.eq(i).val();
            if(value===null)
              value = "";
          }

          if(typeof value!=="undefined" && value!="" && value!=","){
            if(typeof filters.eq(i).attr('data-filter-name')==="undefined"){
              url+= "filter_" + counter + "=" + name + "&value_" + counter + "=" + value;
              if(typeof filters.eq(i).attr('data-filter-operator')!=="undefined"){
                url+= "&operator_" + counter + "=" + filters.eq(i).attr('data-filter-operator');
                filterOperators.push(name+"_"+operator);
              }else{
                filterOperators.push(name+"_");
              }
              url+="&";
              counter++;
            }else{
              url+= filters.eq(i).attr('data-filter-name') + "=" + value+"&";
              filterOperators.push(name+"_");
            }
          }

          checkedFilters.push(name);
        }
      }
      var sort = $("[data-filter-sort]").find("option:selected").val();
      if(typeof sort!=="undefined" && sort!=""){
        url+= "sort="+$("input[name='sort']").val()+"&";
        url+= "sort_order="+$("input[name='sort_order']").val()+"&";
      }

      if(url[url.length-1] == "&"){
        url = url.slice(0,-1);
      }
      top.location.href = url;
    });

    $("[data-filter-sort]").change(function(){
      $("input[name='sort_order']").val($(this).find('option:selected').attr('data-sort-order'));
      $("input[name='sort']").val($(this).find('option:selected').attr('data-sort-field'));
      $("[data-filter-submit]").trigger('click');
    });

    function updateFilterCounter(el,counter){
      el.closest(".mutliSelectWrap").find("[data-filter-choosedcounter]").html(counter);
      if(counter>0){
        el.closest(".mutliSelectWrap").addClass('activeCheck');
        el.closest(".mutliSelectWrap").find("[data-filter-choosedcounter]").show();
      }else{
        el.closest(".mutliSelectWrap").removeClass('activeCheck');
        el.closest(".mutliSelectWrap").find("[data-filter-choosedcounter]").hide();
      }
    }

    $("input[type='checkbox'][data-filter]").bind('click',function(){
      var counter = $(this).closest(".mutliSelect").find("input:checked").length;
      var el = $(this);
      updateFilterCounter(el,counter);
    });

    $("input[type='text'][data-filter]").bind('keyup',function(){
      var counter = $(this).closest(".mutliSelect").find("input[data-filter]").filter(function(){
        return this.value.length>0;
      }).length;
      var el = $(this);
      updateFilterCounter(el,counter);
    });

    $("[data-filter-clear]").click(function(){
      var url = top.location.href.split(",");
      top.location.href = url[0];
    });
  }

  // sticky
  if ( $('.main__sidebar  > div').length && ( $(window).width() > 1024 ) && ( $('.main__content').height() >= $('.main__sidebar  div[data-sticky-class]').height()) )  {
    let sticky = new Sticky('.main__sidebar  > div');
  }


// acordeon
let question = document.querySelectorAll(".question");

question.forEach(question => {
  question.addEventListener("click", event => {
    const active = document.querySelector(".question.active");
    if(active && active !== question ) {
      active.classList.toggle("active");
      active.nextElementSibling.style.maxHeight = 0;
    }
    question.classList.toggle("active");
    const answer = question.nextElementSibling;
    if(question.classList.contains("active")){
      answer.style.maxHeight = answer.scrollHeight + "px";
    } else {
      answer.style.maxHeight = 0;
    }
  })
})


}); // end document ready


$(window).on("scroll", function () {

// js-up
var scroll = $(window).scrollTop();
if (scroll > 600) {
    $(".js-up").addClass("visible");
} else {
    $(".js-up").removeClass("visible");
}

// scrolled menu
if ($(window).scrollTop() > 0){
  $('.js-header').addClass('header--scrolled');
 }else {
     $(".js-header").removeClass("header--scrolled");
 }

}); // end onscroll


if (document.querySelector('.investPage__nav')) {
    const nav = document.querySelector('.investPage__nav');

    const getHeaderHeight = () => window.innerWidth <= 1020 ? 60 : 120;

    const wrapper = document.createElement('div');
    wrapper.classList.add('investPage__nav--sticky');

    const inner = document.createElement('div');
    inner.classList.add('container');

    const navClone = nav.cloneNode(true);

    /* Ikony w pasku to inline SVG z clipPath odwołującym się do id. Klon kopiuje te id
       jeden do jednego, więc w dokumencie są dwa takie same - a url(#id) trafia zawsze do
       pierwszego, czyli do definicji w oryginale. Gdy oryginał znika (visibility: hidden na
       czas przyklejenia paska), ikony w klonie zostają bez clipPatha i po prostu ich nie widać.
       Dlatego w klonie nadajemy id nowe nazwy i przepisujemy odwołania - osobno w każdym svg,
       bo te same id powtarzają się między ikonami (dwie z nich mają clip0_1822_8998). */
    navClone.querySelectorAll('svg').forEach(function (svg, nrIkony) {
        const mapa = {};

        svg.querySelectorAll('[id]').forEach(function (el, i) {
            const stareId = el.getAttribute('id');
            const noweId = stareId + '--sticky' + nrIkony + '-' + i;
            mapa[stareId] = noweId;
            el.setAttribute('id', noweId);
        });

        if (!Object.keys(mapa).length) return;

        /* Odwołania siedzą w atrybutach (clip-path, mask, fill, filter) i w href/xlink:href
           elementów <use>, dlatego przechodzimy po wszystkich atrybutach. */
        svg.querySelectorAll('*').forEach(function (el) {
            Array.prototype.slice.call(el.attributes).forEach(function (attr) {
                if (attr.value.indexOf('#') === -1) return;

                let wartosc = attr.value;
                Object.keys(mapa).forEach(function (stareId) {
                    wartosc = wartosc.split('url(#' + stareId + ')').join('url(#' + mapa[stareId] + ')');
                    if (wartosc === '#' + stareId) wartosc = '#' + mapa[stareId];
                });

                if (wartosc !== attr.value) el.setAttribute(attr.name, wartosc);
            });
        });
    });

    navClone.classList.remove('investPage__nav--sticky');
    navClone.style.position = 'static';
    navClone.style.margin = '0';

    inner.appendChild(navClone);
    wrapper.appendChild(inner);
    document.body.appendChild(wrapper);

    /* Pasek przykleja się w momencie, w którym oryginał dojeżdża pod nagłówek - czyli tak,
       jak zachowywałoby się position: sticky. Klon (fixed) jest tu dlatego, że sticky
       trzymałoby się tylko w obrębie nagłówka strony, a pasek ma zostać widoczny do końca. */
    const updateNav = () => {
        const navTop = nav.getBoundingClientRect().top;
        const przyklejony = navTop <= getHeaderHeight();

        wrapper.classList.toggle('investPage__nav--visible', przyklejony);
        /* Na iOS klon (position: fixed) jest przemalowywany z opóźnieniem podczas bezwładnego
           przewijania i w momencie przyklejania widać oba paski naraz. Dlatego oryginał na ten
           czas znika - visibility, nie display, żeby jego miejsce w układzie zostało i treść
           nie podskoczyła. */
        nav.classList.toggle('investPage__nav--hidden', przyklejony);
    };

    window.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();

    if (document.querySelector('.investPageSearchForm')) {
        const filterBar = document.querySelector('.investPageSearchForm');

        const filterSpacer = document.createElement('div');
        filterBar.parentNode.insertBefore(filterSpacer, filterBar);

        const aboutSection = document.getElementById('about');

        const getStickyTop = () => {
            if (!wrapper.classList.contains('investPage__nav--visible')) return 0;
            const navTopOffset = parseFloat(getComputedStyle(wrapper).top) || 0;
            return navTopOffset + nav.offsetHeight;
        };

        const updateFilterPin = () => {
            if (window.innerWidth <= 1020) {
                filterBar.classList.remove('investPageSearchForm--pinned');
                filterBar.style.top = '';
                filterSpacer.style.height = '0';
                return;
            }

            const stickyTop = getStickyTop();
            const spacerTop = filterSpacer.getBoundingClientRect().top;
            const reachedAbout = aboutSection && aboutSection.getBoundingClientRect().top <= stickyTop + filterBar.offsetHeight;

            if (stickyTop > 0 && spacerTop <= stickyTop && !reachedAbout) {
                if (!filterBar.classList.contains('investPageSearchForm--pinned')) {
                    filterSpacer.style.height = filterBar.offsetHeight + 'px';
                    filterBar.classList.add('investPageSearchForm--pinned');
                }
                filterBar.style.top = stickyTop + 'px';
            } else {
                filterBar.classList.remove('investPageSearchForm--pinned');
                filterBar.style.top = '';
                filterSpacer.style.height = '0';
            }
        };

        window.addEventListener('scroll', updateFilterPin, { passive: true });
        window.addEventListener('resize', updateFilterPin);
        updateFilterPin();
    }
}
  var selectPlaceholder = window.Laravel.lang.forms.selectPlaceholder;

if (document.querySelector('.contactPopup')) {
    const popup = document.querySelector('.contactPopup');
    const openBtns = document.querySelectorAll('.js-popup-open');
    const closeBtns = document.querySelectorAll('.js-popup-close');

    openBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            popup.classList.add('is-open');
            document.body.style.overflow = 'hidden';

            if (window.jQuery) {
                const box = $('.contactPopup__box');
                $('#popup_investment').select2({
                    dropdownParent: box,
                     placeholder: selectPlaceholder,

                   minimumResultsForSearch: Infinity, // hide search field,
                });

                $('#popup_investment').on('select2:open', () => {
                    box.css('overflow-y', 'visible');
                });

                $('#popup_investment').on('select2:close', () => {
                    box.css('overflow-y', 'auto');
                });
            }
        });
    });

    closeBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            popup.classList.remove('is-open');
            document.body.style.overflow = '';
        });
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            popup.classList.remove('is-open');
            document.body.style.overflow = '';
        }
    });
}



document.querySelectorAll('.priceHistoryWrap').forEach(el => {
  const tooltip = el.querySelector('.priceHistoryTooltip');
  if (!tooltip) return;

  el.addEventListener('click', (e) => {
    if (e.target.closest('.priceHistoryTooltip')) return;
    e.stopPropagation();
    const isOpen = tooltip.style.display === 'block';
    document.querySelectorAll('.priceHistoryTooltip').forEach(t => t.style.display = 'none');
    tooltip.style.display = isOpen ? 'none' : 'block';
  });

  tooltip.querySelector('.priceHistoryTooltip__close')?.addEventListener('click', (e) => {
    e.stopPropagation();
    tooltip.style.display = 'none';
  });
});

document.addEventListener('click', () => {
  document.querySelectorAll('.priceHistoryTooltip').forEach(t => t.style.display = 'none');
});
/* Paginacja listy mieszkań przeładowuje stronę (?page=N), więc po powrocie widok stoi na
   samej górze i na telefonie trzeba przewijać do listy ręcznie. Po takim przeładowaniu
   dojeżdżamy sami do pierwszego boxu mieszkania.
   Czekamy na zdarzenie load, bo do tego czasu obrazki mogą jeszcze przesunąć układ.
   Odejmujemy nagłówek i przyklejony pasek nawigacji - inaczej pierwszy box schowałby się
   pod nimi (pasek pokaże się zaraz po przewinięciu, więc liczymy go od razu). */
window.addEventListener('load', function () {
    if (window.innerWidth > 1020) return;
    if (!/[?&]page=/.test(window.location.search)) return;

    var pierwszyBox = document.querySelector('.investPageProducts .investPageProduct');
    if (!pierwszyBox) return;

    var header = document.querySelector('.js-header');
    var investNav = document.querySelector('.investPageHeader .investPage__nav');
    var offset = (header ? header.offsetHeight : 0) + (investNav ? investNav.offsetHeight : 0) + 10;

    window.scrollTo(0, Math.max(0, pierwszyBox.getBoundingClientRect().top + window.pageYOffset - offset));
});

/* Pasek nawigacji inwestycji jest na mobile przewijany w bok, więc po wybraniu sekcji
   dosuwamy ten punkt do lewej krawędzi - inaczej po kliknięciu w ostatni widoczny punkt
   nie wiadomo, gdzie się jest. Robimy to w obu paskach (oryginale i przyklejonym klonie),
   bo mają własne przewinięcie. Pozycję liczymy z różnicy prostokątów, nie z offsetLeft -
   offsetParent paska bywa inny w klonie. */
document.addEventListener('click', function (e) {
  var item = e.target.closest ? e.target.closest('.investPage__nav-item') : null;
  if (!item) return;

  var href = item.getAttribute('href');
  if (!href) return;

  document.querySelectorAll('.investPage__nav').forEach(function (nav) {
    if (nav.scrollWidth <= nav.clientWidth + 1) return;

    var punkt = nav.querySelector('.investPage__nav-item[href="' + href + '"]');
    if (!punkt) return;

    var przesun = punkt.getBoundingClientRect().left
      - nav.getBoundingClientRect().left
      - parseFloat(getComputedStyle(nav).paddingLeft || 0);

    przewinWBok(nav, nav.scrollLeft + przesun);
  });
});

var message = new function() {
    this.show = function(type, message) {
        $.notify({
            message: message
        }, {
            type: type,
            placement: {
                from: "bottom",
                align: "right"
            },
            delay: 5000
        });
    };
};

var form = new function() {
    this.validate = function() {
      if(typeof $("[data-formvalidation]").validate != "undefined"){
        $("[data-formvalidation]").bind('submit',function(){
          var langs = $("[data-metagenerator-trigger]").length;
          if(langs>0){
            var elements = document.querySelectorAll("[data-metagenerator-trigger]");
            var hasValue = false;
            var errorMsg = "";
            var langId;
            if(elements.length>0)
              var parent = $("[data-metagenerator-trigger]").eq(i).closest(".tab-pane");
            for(var i=0;i<elements.length;i++){
              if(elements[i].getAttribute('disabled') === "disabled"){

              }else{
                langId = elements[i].getAttribute('data-lang-id');
                errorMsg+= elements[i].getAttribute('data-formvalidation-label') + ', ';
                if(elements[i].value!=""){
                  hasValue = true;
                  parent.find("input[name='title["+langId+"]']").addClass('requried').attr('required','required');
                  parent.find("input[name='name["+langId+"]']").addClass('requried').attr('required','required');
                  parent.find("input[name='url["+langId+"]']").addClass('requried').attr('required','required');
                }else{
                  parent.find("input[name='title["+langId+"]']").removeClass('requried').removeAttr('required');
                  parent.find("input[name='name["+langId+"]']").removeClass('requried').removeAttr('required');
                  parent.find("input[name='url["+langId+"]']").removeClass('requried').removeAttr('required');
                }
              }
            }

            if(!hasValue){
              message.show("danger",window.Laravel.lang.validation.insert_one_of+': '+errorMsg.trim().slice(0,-1));
              return false;
            }else{
              return true;
            }
          }else{
            return true;
          }
        });
        $("[data-formvalidation]").validate({
            "ignore": [],
            "errorPlacement": function(error, element) {
                console.log(element[0].tagName);
                if (typeof element.attr("data-lang-input") !="undefined" && element.is(":hidden")){
                  //nie pokazujemy komunikatów dla ukrytych langów
                }else if (typeof element.attr("type") != "undefined" && element.attr("type") == "radio") {
                    error.insertAfter(element.parent().find('label'));
                }else if (typeof element.attr("type") != "undefined" && element.attr("type") == "file") {
                    error.insertAfter(element.parent());
                }else if(element[0].tagName.toLowerCase()=="select"){
                    error.insertAfter(element.parent().find(".select2:last"));
                } else {
                    error.insertAfter(element);
                }
            },
            "invalidHandler": function(form, validator) {
                var errors = validator.numberOfInvalids();
                if (errors) {
                    var response = Laravel.lang.validation.invalid, msg;
                    if (validator.errorList.length > 0 && $(this).find("[data-formvalidation-label]").length > 0) {
                        response+= ":<ul>";
                        for (x = 0; x < validator.errorList.length; x++) {
                            msg = validator.errorList[x].message;
                            response+= "<li><b>"+$(validator.errorList[x].element).attr("data-formvalidation-label")+"</b> - "+msg[0].toLowerCase()+msg.slice(1,msg.length)+"</li>";
                        }
                        response+= "</ul>";
                    }

                    message.show('danger',response);
                }
            },
            "submitHandler": function(form){
              if(typeof $(form).attr("data-form-beforesubmit") != "undefined"){
                var functionName = $(form).attr("data-form-beforesubmit").split(".");
                var functionMethod = window;
                for(var i=0; i<functionName.length;i++){
                  functionMethod = functionMethod[functionName[i]];
                }

                return functionMethod();
              }
              return true;
            }
        });
      }
    };

    this.bind = function() {
        this.validate();
    };
};

$(document).ready(function() {
    if (document.querySelector('form'))
      form.bind();

    if(typeof $(".verticalcarousel").owlCarousel !== "undefined" && $(".verticalcarousel").length > 0){
      $(".verticalcarousel").owlCarousel({
          //loop: true,
          items: 1,
          nav: true,
          animateOut: 'fadeOut'
      });
    }


    $(".sliderStatistic").slick({
        arrows: true,
        speed: 700,
        fade: true,
        autoplaySpeed: 7000,
        dots: false,
        infinite: true,
        autoplay: false,
    });


});



function toggleMenu(e) {
  e.classList.toggle("active");
  document.querySelector(".adminSidebar").classList.toggle("active");
}
//# sourceMappingURL=subpage.js.map
